import React, { useState, useEffect, useMemo, useRef } from "react";
import { QuietSaveGate } from "./steps/quietSaveGate";
import {
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { useHistory, useLocation } from "react-router-dom";
import ReactChipInput from "react-chip-input";
import { HKPImage } from "../../media/HKPImage";
//components
import CreateUserModal from "../users/CreateUserModal";
import ShowIcon from "../../common/Components/Icons/ShowIcon";
import HideIcon from "../../common/Components/Icons/HideIcon";
import ImageDivPart from "./ImageDivPart";
import { debounce } from "../../common/commonFiles/debounce";
import notifications from "../../common/Components/Notifications/Notification";
// import FilePreview from "./FilePreviewProduct";
import Loader from "../../common/Components/Loader/Loader";
import ArtformModal from "../artform/ArtformModal";
import GiFrozenSelect from "../gi-registry/GiFrozenSelect";
import TypeModal from "../type/TypeModal";
import CategoryModal from "../category/CategoryModal";
import SubCategoryModal from "../sub-category/SubCategoryModal";
import WeaveTypeModal from "../weave-type/WeaveTypeModal";
import { canUseProductCapture } from "../../helpers/productCaptureEnabled";
import ProductAttributesSection from "../../taxonomy/ProductAttributesSection";
import { getOrganizationTaxonomyConfig, listProcessFieldMappingsByProcess } from "../../taxonomy/taxonomyApi";
import type { ResolvedFieldConfig, TaxonomyValues } from "../../taxonomy/types";
import {
  isWeaveTypeApplicable,
  mergeTaxonomyValues,
  parseCustomFieldsRequired,
} from "../../taxonomy/values";
import { missingPublishFields as collectMissingPublishFields, resolvePublishFailure, RequiredField } from "../../taxonomy/publishFields";
import { customFieldsCopy } from "../../taxonomy/copy";
import { baseImageCovert, baseImageCovertForLogoPin } from "./baseImageConver";
import {
  collectUniqueFiles,
  mergePersistedWithLocalPreviews,
  persistableMediaUrl,
  mediaForProductWrite,
  persistableThumbnailRows,
  replaceLocalPreviewsWithUploaded,
  shouldShowMediaUploadSpinner,
  isShownMedia,
  mediaItemsAtVisibleIndexes,
  dropMediaItems,
  pickEditorCoverUrl,
  isLocalMediaItem,
  previewMediaUrl,
} from "./previewMedia";
import { filledOwnersFromProduct } from "./productOwnership";
// actions
import { getArtforms } from "../../Store/artform/actions";
import { createUser, updateUsers } from "../../Store/users/actions";
import {
  fetchProfilePresignedUrl,
  fetchProductWeavingPresignedUrl,
  fetchProductDesigningPresignedUrl,
  fetchProductFinishingPresignedUrl,
  fetchProductDyingPresignedUrl,
  uploadImages,
  uploadImages1,
} from "../../Store/uploadModule/actions";
import { getUsers } from "../../Store/users/actions";
import { getCategory } from "../../Store/actions";
import { getSubCategorys } from "../../Store/actions";
import { getTypes } from "../../Store/type/actions";
import { getWeaveType } from "../../Store/weave-type/actions";
import {
  updateProducts,
  getProducts,
  createVariantForProduct,
  enrichProductAi,
  acceptProductAi,
  rejectProductAi,
  getSimilarProducts,
} from "../../Store/products/actions";
import FilePreviewPart from "./FilePreviewPart";
import {
  ProcessStepsSection,
  parseProcessStepsFromApi,
  serializeProcessStepsForApi,
} from "./ProcessStepsSection";
import ProductCareSection from "../../care/ProductCareSection";
import { ProductInternalUseSection } from "./ProductInternalUseSection";
import { formatRupee } from "./list/productListRow";
import {
  FlexibleMediaProcessesSection,
  buildFlexSlotsFromProduct,
  flexSlotsToPayloadProcesses,
  toProcessMasterOption,
  ProcessMasterOption,
} from "./FlexibleMediaProcessesSection";
import { isProductDraftRevisionsEnabled } from "../../uploads/productDraftRevisionsEnabled";
import { applyDraftOverlay, deleteDraftMedia, masterIdFromRef, masterIdsForProductWrite, masterNameFromRef, patchDraftMedia, publishProductDraft } from "../../uploads/productDraftApi";
import {
  cancelProductMedia,
  enqueueProductMedia,
  summarizeUploads,
  setProductMediaView,
} from "../../uploads/productMediaUploadManager";
import { newMediaId } from "../../uploads/fileTypeFromMime";
import { useProductMediaUploads } from "../../uploads/ProductMediaUploadContext";
import { isFlexibleProcessWorkflow } from "./productProcessMigrationUtils";
import { mongoIdForProductUpdate } from "./productProcessIdentity";
import { isDraftStatus } from "./productStockDisplay";
import { isSareeLikeProduct, productWeightLabel } from "./productSareeFields";
import ProductAiSuggestions from "./ProductAiSuggestions";
import ImageClose from "../../common/Components/Icons/ImageClose";
import ImageAddIcon from "../../common/Components/Icons/ImageAddIcon";
import { AddIcon } from "../../common/Components/Icons/AddIcon";
import CreateVariant from "./CreateVariant";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
import CircleLoader from "../../common/Components/Loader/CircleLoader";
import DownloadIcon from "../../common/Components/Icons/DownloadIcon";
import Pin from "../../common/Components/Icons/Pin";
import Unpin from "../../common/Components/Icons/Unpin";
import ResetIcon from "../../common/Components/Icons/ResetIcon";
import {
  zariUsedOptions,
  timeTakenInMonthsOptions,
  yarnUsedOptions,
  typeOfSareeByDesignOptions,
} from "./options";
import ProductImagePreView from "./ProductImagePreView";
import ViewEyeIcon from "../../common/Components/Icons/ViewEyeIcon";
import { getApi, postApi } from "../../helpers/auth_helpers";
import ProductDescriptionField from "./common components/ProductDescriptionField";
import ProductFamilyBar from "./ProductFamilyBar";
import TaxonomyRequiredSummary from "../../taxonomy/TaxonomyRequiredSummary";
import { flushSync } from "react-dom";
import {
  DetailsGroup,
  ProductStepFooter,
  ProductStepHeader,
  ProductStepPanel,
  ReviewChecklist,
  StepButton,
} from "./steps/ProductStepShell";
import TypeTagPicker from "./steps/TypeTagPicker";
import TypeTagReviewBanner from "./steps/TypeTagReviewBanner";
import { isTypeTagsEnabled } from "../../helpers/typeTagsEnabled";
import {
  PRODUCT_STEPS,
  ProductStepId,
  DETAIL_GROUP_KEYS,
  buildReviewItems,
  groupSummary,
  nextStep,
  previousStep,
  stepFromSearch,
  stepIndex,
  stepOfElement,
} from "./steps/productSteps";
import CategoryPathPicker from "./steps/CategoryPathPicker";
import { CategoryPath } from "./steps/categoryPathSearch";
import WriteFromPhotos from "./steps/WriteFromPhotos";
import PhotoGrid from "./steps/PhotoGrid";
import { coverageOf, missingWords, normalizeSkipped, viewSlotsFor } from "./steps/mediaViews";
import ColourChips from "./steps/ColourChips";
import PublishChangesSheet from "./steps/PublishChangesSheet";
import { draftChanges, pendingDraftFromForm } from "./steps/productDraftDiff";
import {
  parseOrgSrNo,
  resolveHkpTagLookup,
} from "../../services/hkpNfcTagApi";
import LoomNumberField from "./LoomNumberField";

// selector options
var artformOptions: any = [];
var typeOptions: any = [];
var categoryOptions: any = [];
var designerOptions: any = [];
var weaverOptions: any = [];
var dyerOptions: any = [];
var finisherOptions: any = [];
let subCategoryOptions: any = [];
let weaveTypeOptions: any = [];

// logo
let fileObjLogo: any = [];
let fileArrayLogo: any = [];
let promiseForLogo: any = [];
let promiseLogoUrl: any = [];
let promiseLogoStatusCode: any = [];

// designing
let fileObjDesign: any = [];
let fileArray: any = [];
let promiseForDesign: any = [];
let promiseDesignUrl: any = [];
let promiseDesignStatusCode: any = [];
// weaving
let fileObjWeaving: any = [];
let fileArrayWeaving: any = [];
let promiseForWeaving: any = [];
let proWeavingUrl: any = [];
let proWeavingCodes: any = [];
// dying
let fileObjDying: any = [];
let fileArrayDying: any = [];
let promiseForDying: any = [];
let proDyingUrl: any = [];
let proDyingCodes: any = [];
// finishing
let fileObjFinishing: any = [];
let fileArrayFinishing: any = [];
let promiseForFinishing: any = [];
let proFinishingUrl: any = [];
let proFinishingUCodes: any = [];
// variant
let fileObjVariant: any = [];
let fileArrayVariant: any = [];
let promiseForVariant: any = [];
type ProcessMasterOpt = ProcessMasterOption;
let promiseVariantUrl: any = [];
let promiseVariantStatusCode: any = [];

let allStatusCodes: any = [];
let fileObjImages: any = [];
// let uniqueArr: any = [];

var productMainImageStatusCode: any = [];

/** The small cover in the review card and the laptop aside: the 320 copy, lazy, so a hidden card loads nothing. */
const PreviewCoverImage = ({ url }: { url: string }) => (
  <HKPImage
    preset="THUMBNAIL"
    localPreviewUrl={url.startsWith("blob:") ? url : undefined}
    legacyUrl={url}
    alt=""
  />
);

const EditProduct = (props: any) => {
  const history = useHistory();
  const location: any = useLocation();
  const ProductId: any = location?.pathname.split("/")[2];
  const ProductName: any = location?.state?.productDetails?.name;
  const [form, setForm]: any = useState({
    artform: "",
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    productName: "",
    designer: "",
    designerMedia: [],
    weaver: "",
    weaverMedia: [],
    dyer: "",
    dyerMedia: [],
    finisher: "",
    finisherMedia: [],
    profileURL: [],
    tags: [],
    singleTag: "",
    id: "",
    status: "",
    variantCode: "",
    description: "",
    // new
    nameOfBrand: "",
    nameOfWeaver: "",
    weightOfSaree: "",
    zariUsed: "",
    silkMark: true,
    handloomMark: true,
    madeInIndia: true,
    weightOfZariUsed: "",
    yarnType: "",
    workingHours: "",
    xuid: "",
    xuidFromRegistry: false,
    // new fields
    SrNo: "",
    orgSrNo: "",
    parentId: "",
    productUniqueId: "",
    weavingCenter: "Varanasi",
    giId: "",
    typeOfSareeByDesign: "",
    productionTimeInMonths: "",
    sellPrice: "",
    costPrice: "",
    designNum: "",
    inStock: false,
    processSteps: [] as { title: string; text: string }[],
    flexUploadSlots: [] as any[],
    processWorkflowVersion: "",
    taxonomyValues: {} as TaxonomyValues,
  });
  const [flexPendingFiles, setFlexPendingFiles] = useState<Record<string, File[]>>({});
  const [flexUploadDirty, setFlexUploadDirty] = useState(false);
  const [hasDraftChanges, setHasDraftChanges] = useState(false);
  // The product as loaded (live fields + its saved `draft`), for the "Publish changes" old → new list.
  const [rawLiveProduct, setRawLiveProduct] = useState<any>(null);
  const [step, setStep] = useState<ProductStepId>(() => stepFromSearch(location?.search, "basics"));
  const [levelsOpen, setLevelsOpen] = useState(false);
  const [publishSheetOpen, setPublishSheetOpen] = useState(false);
  // Opened right after Add product saved the draft.
  const isFreshDraft = new URLSearchParams(location?.search || "").get("new") === "1";
  const uploadJobs = useProductMediaUploads(form?.id || ProductId);
  const flexSlotsRef = useRef(form.flexUploadSlots);
  // Blocks a second Save/Publish while one is in flight; set before any await in handleSubmit.
  const submittingRef = useRef(false);
  const handedOffRef = useRef(false);
  // Moving between steps saves the draft in place (owner decision 2026-10-29: never lose a half-filled piece).
  const stayAfterSaveRef = useRef(false);
  const quietGate = useRef(new QuietSaveGate()).current;
  const [quietTick, setQuietTick] = useState(0);
  const markEdited = () => quietGate.mark();
  const [autoSavedAt, setAutoSavedAt] = useState<number | null>(null);
  const [saving, setSaving] = useState<null | "save" | "publish">(null);
  const releaseSubmit = () => {
    submittingRef.current = false;
    setSaving(null);
    // A quiet save asked for while this one ran gets its turn now (see quietSave).
    if (quietGate.pending) setQuietTick((n) => n + 1);
  };
  flexSlotsRef.current = form.flexUploadSlots;
  const [processMasterOptions, setProcessMasterOptions] = useState<ProcessMasterOpt[]>([]);
  const [productTaxonomyFields, setProductTaxonomyFields] = useState<ResolvedFieldConfig[]>([]);
  const [processTaxonomyFields, setProcessTaxonomyFields] = useState<ResolvedFieldConfig[]>([]);
  const [taxonomyConfigError, setTaxonomyConfigError] = useState("");
  const [taxonomyConfigLoading, setTaxonomyConfigLoading] = useState(false);
  const [missingPublishFields, setMissingPublishFields] = useState<RequiredField[]>([]);
  const [weaveTypeApplicable, setWeaveTypeApplicable] = useState(true);
  const showRequiredFields = async (response: any) => {
    const ids = parseCustomFieldsRequired(response);
    if (!ids.length) return false;
    const [productRes, processRes] = await Promise.all([
      getOrganizationTaxonomyConfig("PRODUCT"), getOrganizationTaxonomyConfig("PROCESS"),
    ]);
    const productFields = productRes.success ? productRes.data || [] : productTaxonomyFields;
    const processFields = processRes.success ? processRes.data || [] : processTaxonomyFields;
    setProductTaxonomyFields(productFields);
    setProcessTaxonomyFields(processFields);
    const blocked = await resolvePublishFailure(ids, productFields, form.taxonomyValues,
      processFields, form.flexUploadSlots || [], processMasterOptions);
    setMissingPublishFields(blocked);
    openStepFor(document.getElementById(blocked[0]?.focusId || "hkp-product-attributes"));
    window.setTimeout(() => document.getElementById("ps-missing")?.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
    return true;
  };

  const [loader, setLoader]: any = useState(false);
  const [loaderVariant, setLoaderVariant]: any = useState({
    submit: false,
    images: false,
  });
  const [variantForm, setVariantForm]: any = useState({
    variantCode: "",
    images: [],
  });
  const [baseindex, setBaseIndex]: any = useState({
    designing: "",
    dying: "",
    weaving: "",
    finishing: "",
    logo: "",
  });
  const [Error, setError]: any = React.useState({
    artform: "",
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    product: "",
    SrNo: "",
  });
  const [ErrorForVariant, setErrorForVariant]: any = useState({
    color: "",
  });
  const [filterValue, setFilterValue]: any = useState({
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    product: "",
  });
  const [openModal, setOpenModal]: any = useState({
    artform: false,
    type: false,
    category: false,
    subCategory: false,
    weaveType: false,
    variant: false,
    designing: false,
    dying: false,
    weaving: false,
    finishing: false,
  });
  const [handleNameFlag, setHandleNameFlag]: any = useState({
    designing: false,
    weaving: false,
    dying: false,
    finishing: false,
  });
  const [deleteIndexLogo, setDeleteIndexLogo]: any = useState();
  const [baseindexForLogo, setBaseIndexForLogo]: any = useState("");

  const [mainImageLoader, setMainImageLoader]: any = useState(false);

  const [filterProduct, setFilterProduct]: any = useState("");
  const [aiEnrichment, setAiEnrichment]: any = useState(null);

  const [loading, setLoading]: any = useState(false);
  const [baseImageLogo, setBaseImageLogo]: any = useState([]);
  const visibleMediaIds = [
    ...(baseImageLogo || []).map((img: any) => img?.mediaId),
    ...((form.flexUploadSlots || []).flatMap((slot: any) =>
      (slot.baseImages || []).map((img: any) => img?.mediaId)
    )),
  ].filter(Boolean);
  const uploadSummary = summarizeUploads(form?.id || ProductId, visibleMediaIds);
  const [baseImageDying, setBaseImageDying]: any = useState([]);
  const [baseImageDesigner, setBaseImageDesigner]: any = useState([]);
  const [baseImageVariant, setBaseImageVariant]: any = useState([]);

  const [deleteIndexDesigner, setDeleteIndexDesigner]: any = useState();
  const [deleteIndexWeaver, setDeleteIndexWeaver]: any = useState();
  const [deleteIndexDying, setDeleteIndexDying]: any = useState();
  const [deleteIndexFinisher, setDeleteIndexFinisher]: any = useState();
  const [deleteIndexVariant, setDeleteIndexVariant]: any = useState();

  const [baseImageWeaver, setBaseImageWeaver]: any = useState([]);
  const [baseImageFinisher, setBaseImageFinisher]: any = useState([]);

  const [selectedFile, setSelectedFile]: any = useState();
  const [selectedFileDying, setSelectedFileDying]: any = useState();
  const [selectedFileWeaver, setSelectedFileWeaver]: any = useState();
  const [selectedFileDesigner, setSelectedFileDesigner]: any = useState();
  const [selectedFileFinisher, setSelectedFileFinisher]: any = useState();
  const [selectedFileVariant, setSelectedFileVariant]: any = useState();
  const [isOpen, setIsOpen]: any = useState(false);
  const [image, setImage]: any = useState("");

  const [selectTab, setSelectTab]: any = useState("");
  const [selectTab1, setSelectTab1]: any = useState("");

  const fileInputProfile: any = React.useRef();
  const fileInputDesigner: any = React.useRef();
  const fileInputWeaver: any = React.useRef();
  const fileInputUploadDying: any = React.useRef();
  const fileInputFinisher: any = React.useRef();
  const fileInputVariant: any = React.useRef();

  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let organizationId =
    authUser?.users?.role === "ORGANIZATION_MANAGER" ||
      authUser?.users?.role === "ORGANIZATION_ADMIN"
      ? authUser?.users?.organizationResponse?._id
      : "";

  const handleHkpTagNoBlur = async (tagNo: string) => {
    const result = await resolveHkpTagLookup(tagNo, form?.productUniqueId || ProductId);
    if (result.fromRegistry && result.xuid) {
      setForm((current: any) => ({
        ...current,
        xuid: result.xuid,
        xuidFromRegistry: true,
      }));
      return;
    }
    if (result.legacy) {
      setForm((current: any) => ({
        ...current,
        xuidFromRegistry: false,
        xuid: current?.xuidFromRegistry ? "" : current?.xuid,
      }));
      return;
    }
    if (result.error) {
      notifications({
        title: "HKP tag",
        message: result.error,
        type: "danger",
      });
      setForm((current: any) => ({ ...current, xuidFromRegistry: false }));
    }
  };

  const fileUploadTriggerVariant = () => {
    fileInputVariant.current.click();
  };
  const fileUploadTrigger = () => {
    fileInputProfile.current.click();
  };
  const fileUploadTriggerWeaver = () => {
    fileInputWeaver.current.click();
  };
  const fileUploadTriggerDesigner = () => {
    fileInputDesigner.current.click();
  };

  const fileUploadTriggerFinisher = () => {
    fileInputFinisher.current.click();
  };

  const fileUploadTriggerDying = () => {
    fileInputUploadDying.current.click();
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleSetImage = (image: any) => {
    setImage(image);
  };
  useEffect(() => {
    if (location.pathname.split("/")[1] === "edit-product") {
      resetVariables();
      fileArray = [];
      fileArrayDying = [];
      fileArrayFinishing = [];
      fileArrayWeaving = [];
      fileObjDesign = [];
      fileObjDying = [];
      fileObjLogo = [];
      fileObjFinishing = [];
      fileObjWeaving = [];
      fileObjVariant = [];
      productMainImageStatusCode = [];

      // uniqueArr = [];
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    setTaxonomyConfigLoading(true);
    Promise.all([
      getOrganizationTaxonomyConfig("PRODUCT"),
      getOrganizationTaxonomyConfig("PROCESS"),
    ]).then(([productRes, processRes]) => {
      if (cancelled) return;
      if (productRes.success) {
        setProductTaxonomyFields(productRes.data || []);
        setWeaveTypeApplicable(isWeaveTypeApplicable(productRes.data));
        setTaxonomyConfigError("");
      } else {
        setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      }
      if (processRes.success) {
        setProcessTaxonomyFields(processRes.data || []);
      } else {
        setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      }
      setTaxonomyConfigLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const loadProcessMasters = async () => {
    try {
      const url = `${process.env.REACT_APP_SERVERURL}/product-process-master/list`;
      const response: any = await getApi(url);
      if (response?.success && Array.isArray(response?.data)) {
        const next = await Promise.all(response.data.map(async (item: any) => {
          const base = toProcessMasterOption(item);
          const mappings = base.value ? await listProcessFieldMappingsByProcess(base.value) : null;
          return toProcessMasterOption(item, mappings?.success ? mappings.data || [] : undefined);
        }));
        setProcessMasterOptions(next);
      }
    } catch (error) {
      // keep form usable even if master API fails
    }
  };

  const createProcessMaster = async (name: string, description: string, inhouse: boolean) => {
    const payload = {
      name: String(name || "").trim(),
      description: String(description || "").trim(),
      inhouse,
    };
    if (!payload.name) return null;
    try {
      const url = `${process.env.REACT_APP_SERVERURL}/product-process-master/upsert`;
      const response: any = await postApi(url, payload);
      if (!response?.success || !response?.data) {
        notifications({
          title: "Error!",
          message: response?.message || "Unable to save process master",
          type: "danger",
        });
        return null;
      }
      const created = toProcessMasterOption({
        ...response.data,
        name: response.data?.name || payload.name,
        description: response.data?.description || payload.description,
        inhouse: response.data?.inhouse === false ? false : true,
      }, []);
      setProcessMasterOptions((prev) => {
        const rest = prev.filter((p) => p.label.toLowerCase() !== created.label.toLowerCase());
        return [...rest, created].sort((a, b) => a.label.localeCompare(b.label));
      });
      return created;
    } catch (error) {
      notifications({
        title: "Error!",
        message: "Unable to save process master",
        type: "danger",
      });
      return null;
    }
  };

  useEffect(() => {
    loadProcessMasters();
  }, []);
  useEffect(() => {
    if (ProductId) {
      getAllData();
    }
  }, [ProductId]);

  useEffect(() => {
    if (!uploadJobs.length) {
      return;
    }
    const byId: Record<string, (typeof uploadJobs)[0]> = {};
    uploadJobs.forEach((job) => {
      byId[job.mediaId] = job;
    });
    const matchJob = (img: any) => (img?.mediaId ? byId[img.mediaId] : null);
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: (f.flexUploadSlots || []).map((s: any) => ({
        ...s,
        baseImages: (s.baseImages || []).map((img: any) => {
          const job = matchJob(img);
          if (!job) {
            return img;
          }
          return {
            ...img,
            mediaId: job.mediaId,
            uploadStatus: job.status,
            uploadProgress: job.progress,
            uploadError: job.error,
            blobImage: job.storageUrl || img.blobImage,
            mediaURL: job.storageUrl || img.mediaURL,
            mediaAssetId: job.mediaAssetId || img.mediaAssetId,
            _local: job.status !== "UPLOADED",
          };
        }),
      })),
    }));
    setBaseImageLogo((prev: any[]) =>
      (prev || []).map((img: any) => {
        const job = matchJob(img);
        if (!job) {
          return img;
        }
        return {
          ...img,
          mediaId: job.mediaId,
          uploadStatus: job.status,
          uploadProgress: job.progress,
          uploadError: job.error,
          blobImage: job.storageUrl || img.blobImage,
          mediaURL: job.storageUrl || img.mediaURL,
          mediaAssetId: job.mediaAssetId || img.mediaAssetId,
          _local: job.status !== "UPLOADED",
        };
      })
    );
  }, [uploadJobs]);

  const getAllData = () => {
    setLoading(true);
    props.getProducts(
      {
        offset: 0,
        limit: 10,
        ProductId: ProductId,
        // ProductsName:ProductName
      },
      (res: any) => {
        setLoading(false);
        try {
        const rawProduct = res?.data?.docs?.[0];
        if (!rawProduct) {
          notifications({
            title: "Notice",
            message: "This product could not be loaded.",
            type: "danger",
          });
          return;
        }
        if (res?.data) {
          let editDetails: any = applyDraftOverlay(rawProduct);
          setHasDraftChanges(Boolean(rawProduct?.hasDraftChanges));
          setRawLiveProduct(rawProduct);
          if (editDetails?.thumbnailDetails?.media?.length > 0) {
            setBaseImageLogo(
              baseImageCovertForLogoPin(editDetails?.thumbnailDetails?.media)
            );
          } else if (
            // editDetails?.thumbnailDetails === null &&
            editDetails?.thumbnail?.length > 0
          ) {
            setBaseImageLogo(
              baseImageCovertForLogoPin([
                {
                  mediaURL: editDetails?.thumbnail,
                  show: "1",
                  pin: "1",
                },
              ])
            );
          }
          if (editDetails?.designingDetails?.media) {
            setBaseImageDesigner(
              baseImageCovert(editDetails?.designingDetails?.media)
            );
          }
          if (editDetails?.dyingDetails?.media) {
            setBaseImageDying(
              baseImageCovert(editDetails?.dyingDetails?.media)
            );
          }
          if (editDetails?.weavingDetails?.media) {
            setBaseImageWeaver(
              baseImageCovert(editDetails?.weavingDetails?.media)
            );
          }
          if (editDetails?.finishingDetails?.media) {
            setBaseImageFinisher(
              baseImageCovert(editDetails?.finishingDetails?.media)
            );
          }
          const flexibleWorkflow = isFlexibleProcessWorkflow(editDetails);
          setAiEnrichment(editDetails?.aiEnrichment || null);
          setForm({
            id: editDetails?._id,
            artform: {
              value: masterIdFromRef(editDetails?.artform),
              label: masterNameFromRef(editDetails?.artform),
            },
            type: {
              value: masterIdFromRef(editDetails?.type),
              label: masterNameFromRef(editDetails?.type),
            },
            category: {
              value: masterIdFromRef(editDetails?.category),
              label: masterNameFromRef(editDetails?.category),
            },
            subCategory: {
              value: masterIdFromRef(editDetails?.subcategory),
              label: masterNameFromRef(editDetails?.subcategory),
            },
            weaveType: {
              value: masterIdFromRef(editDetails?.weavetype),
              label: masterNameFromRef(editDetails?.weavetype),
            },
            productName: editDetails?.name,
            designer:
              editDetails?.designingDetails?.karigar?.name?.length > 0
                ? {
                  label: editDetails?.designingDetails?.karigar?.name,
                  value: editDetails?.designingDetails?.karigar?._id,
                }
                : "",
            designerMedia:
              editDetails?.designingDetails?.media?.[0]?.mediaURL?.length > 0 &&
                editDetails?.designingDetails?.media?.length > 0
                ? editDetails?.designingDetails?.media
                  .filter((ele: any) => {
                    if (ele?.mediaURL?.length > 0) {
                      return {
                        mediaUrl: ele?.mediaURL,
                        show: isShownMedia(ele) ? 1 : 0,
                      };
                    }
                  })
                  .map((ele1: any, i: any) => {
                    return {
                      mediaUrl: ele1?.mediaURL,
                      show: isShownMedia(ele1) ? 1 : 0,
                    };
                  })
                : [],
            weaver:
              editDetails?.weavingDetails?.karigar?.name?.length > 0
                ? {
                  label: editDetails?.weavingDetails?.karigar?.name,
                  value: editDetails?.weavingDetails?.karigar?._id,
                }
                : "",
            weaverMedia:
              editDetails?.weavingDetails?.media?.length > 0 &&
                editDetails?.weavingDetails?.media?.[0]?.mediaURL?.length > 0
                ? editDetails?.weavingDetails?.media
                  .filter((ele: any) => {
                    if (ele?.mediaURL?.length > 0) {
                      return {
                        mediaUrl: ele?.mediaURL,
                        show: isShownMedia(ele) ? 1 : 0,
                      };
                    }
                  })
                  .map((ele1: any, i: any) => {
                    return {
                      mediaUrl: ele1?.mediaURL,
                      show: isShownMedia(ele1) ? 1 : 0,
                    };
                  })
                : [],
            dyer:
              editDetails?.dyingDetails?.karigar?.name?.length > 0
                ? {
                  label: editDetails?.dyingDetails?.karigar?.name,
                  value: editDetails?.dyingDetails?.karigar?._id,
                }
                : "",
            dyerMedia:
              editDetails?.dyingDetails?.media?.length > 0 &&
                editDetails?.dyingDetails?.media?.[0]?.mediaURL?.length > 0
                ? editDetails?.dyingDetails?.media
                  .filter((ele: any) => {
                    if (ele?.mediaURL?.length > 0) {
                      return {
                        mediaUrl: ele?.mediaURL,
                        show: isShownMedia(ele) ? 1 : 0,
                      };
                    }
                  })
                  .map((ele1: any, i: any) => {
                    return {
                      mediaUrl: ele1?.mediaURL,
                      show: isShownMedia(ele1) ? 1 : 0,
                    };
                  })
                : [],
            finisher:
              editDetails?.finishingDetails?.karigar?.name?.length > 0
                ? {
                  label: editDetails?.finishingDetails?.karigar?.name,
                  value: editDetails?.finishingDetails?.karigar?._id,
                }
                : "",
            finisherMedia:
              editDetails?.finishingDetails?.media?.length > 0 &&
                editDetails?.finishingDetails?.media?.[0]?.mediaURL?.length > 0
                ? editDetails?.finishingDetails?.media
                  .filter((ele: any) => {
                    if (ele?.mediaURL?.length > 0) {
                      return {
                        mediaUrl: ele?.mediaURL,
                        show: isShownMedia(ele) ? 1 : 0,
                      };
                    }
                  })
                  .map((ele1: any, i: any) => {
                    return {
                      mediaUrl: ele1?.mediaURL,
                      show: isShownMedia(ele1) ? 1 : 0,
                    };
                  })
                : [],
            profileURL:
              editDetails?.thumbnailDetails?.media?.length > 0 &&
                editDetails?.thumbnailDetails?.media?.[0]?.mediaURL?.length > 0
                ? editDetails?.thumbnailDetails?.media
                  .filter((ele: any) => {
                    if (ele?.mediaURL?.length > 0) {
                      return {
                        mediaUrl: ele?.mediaURL,
                        show: isShownMedia(ele) ? 1 : 0,
                        pin: ele?.pin === "1" ? 1 : 0,
                      };
                    }
                  })
                  .map((ele1: any, i: any) => {
                    return {
                      mediaUrl: ele1?.mediaURL,
                      show: isShownMedia(ele1) ? 1 : 0,
                      pin: ele1?.pin === "1" ? 1 : 0,
                    };
                  })
                : editDetails?.thumbnail?.length > 0
                  ? [
                    {
                      mediaUrl: editDetails?.thumbnail,
                      show: 1,
                      pin: 1,
                    },
                  ]
                  : [],
            ...filledOwnersFromProduct(editDetails),
            tags: editDetails?.tags ? editDetails?.tags : [],
            typeTagIds: Array.isArray(editDetails?.typeTagIds) ? editDetails.typeTagIds : undefined,
            typeTagReview: editDetails?.typeTagReview || undefined,
            status: editDetails.status,
            variantCode: editDetails?.color,
            description: editDetails?.description || "",
            //new
            nameOfBrand: editDetails?.brand,
            nameOfWeaver: editDetails?.weaver,
            handloomMark: editDetails?.handloom,
            silkMark: editDetails?.silk,
            zariUsed: { label: editDetails?.zari, value: editDetails?.purity },
            weightOfSaree: editDetails?.sareeWeight,
            weightOfZariUsed: editDetails?.zariWeight,
            purity: editDetails?.purity,
            madeInIndia: true,
            yarnType: editDetails?.yarnType
              ? {
                label: editDetails?.yarnType,
                value: editDetails?.yarnType,
              }
              : "",
            workingHours: editDetails?.workingHours,
            loomNum: editDetails?.loomNum,
            // Read-only: names downloaded photos (SKU_name_view_loomnum); never sent back on save.
            productCertificateNumber: editDetails?.productCertificateNumber || "",
            xuid: editDetails?.xuid,
            xuidFromRegistry: false,
            SrNo: editDetails?.srNo,
            orgSrNo: editDetails?.orgSrNo,
            parentId: editDetails?.parentId,
            productUniqueId: editDetails?.productUniqueId,
            weavingCenter: editDetails?.weavingCenter || form?.weavingCenter,
            giId: editDetails?.giId || "",
            typeOfSareeByDesign: editDetails?.typeOfSareeByDesign
              ? {
                label: editDetails?.typeOfSareeByDesign,
                value: editDetails?.name,
              }
              : "",
            // No saved time → no value, so the picker shows "Select" instead of an empty box.
            productionTimeInMonths: editDetails?.productionTimeInMonths
              ? {
                  label: editDetails?.productionTimeInMonths,
                  value: editDetails?.workingHours,
                }
              : "",
            costPrice: editDetails?.costPrice,
            sellPrice: editDetails?.sellPrice,
            inStock: editDetails?.inStock === true,
            designNum: editDetails?.designNum,
            processSteps: parseProcessStepsFromApi(editDetails?.processSteps),
            flexUploadSlots: buildFlexSlotsFromProduct(editDetails, baseImageCovert),
            processWorkflowVersion: flexibleWorkflow ? "flexible" : "legacy",
            publishedRevision: rawProduct?.publishedRevision,
            draftRevision: rawProduct?.draftRevision,
            taxonomyValues: editDetails?.taxonomyValues || {},
            mediaViewsSkipped: normalizeSkipped(editDetails?.mediaViewsSkipped),
          });
          setWeaveTypeApplicable(isWeaveTypeApplicable(editDetails));
          setFlexUploadDirty(false);
          if (editDetails?.srNo) {
            resolveHkpTagLookup(editDetails.srNo, editDetails.productUniqueId).then((result) => {
              if (result.fromRegistry) {
                setForm((current: any) => ({
                  ...current,
                  xuidFromRegistry: true,
                  xuid: result.xuid || current.xuid,
                }));
              }
            });
          }
        }
        } catch (e: any) {
          notifications({
            title: "Notice",
            message: e?.message || "Could not open this product.",
            type: "danger",
          });
        }
      }
    );
  };

  const getWeaveTypeData = (data?: any) => {
    props.getWeaveType(
      {
        offset: 0,
        limit: 10,
        artformId: form?.artform?.value || data?.artform,
        typeId: form?.type?.value || data?.type,
        categoryId: form?.category?.value || data?.category,
        subCategoryId: form?.subCategory?.value || data?.subCategory,
        weaveTypeId: form?.weaveType?.value,
        weaveTypeName: data?.value,
      },
      (res: any) => {
        weaveTypeOptions = [];
        res?.data?.docs.map((ele: any) => {
          weaveTypeOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getSubCategoryData = (data?: any) => {
    props.getSubCategorys(
      {
        offset: 0,
        limit: 10,
        typeId: form?.type?.value || data?.type,
        artformId: form?.artform?.value || data.artform,
        categoryId: form?.category?.value || data?.category,
        subCategoryName: data?.value,
      },
      (res: any) => {
        subCategoryOptions = [];
        res?.data?.docs.map((ele: any) => {
          subCategoryOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getCreatorsData = (data?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        userId: data?.userId,
      },
      (res: any) => {
        designerOptions = [];
        res?.data?.docs.map((ele: any) => {
          let formValues = form;
          if (data?.name === "designing") {
            formValues = {
              ...formValues,
              designer: {
                label: res?.data?.docs[0]?.name,
                value: {
                  id: res?.data?.docs[0]?._id,
                  roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                },
              },
            };
            getCreatorsDataDesignerOption();
          }
          if (data?.name === "weaving") {
            formValues = {
              ...formValues,
              weaver: {
                label: res?.data?.docs[0]?.name,
                value: {
                  id: res?.data?.docs[0]?._id,
                  roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                },
              },
            };
            getCreatorsDataWeaverOption();
          }
          if (data?.name === "dying") {
            formValues = {
              ...formValues,
              dyer: {
                label: res?.data?.docs[0]?.name,
                value: {
                  id: res?.data?.docs[0]?._id,
                  roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                },
              },
            };
            getCreatorsDataDyingOption();
          }
          if (data?.name === "finishing") {
            formValues = {
              ...formValues,
              finisher: {
                label: res?.data?.docs[0]?.name,
                value: {
                  id: res?.data?.docs[0]?._id,
                  roleId: res?.data?.docs[0]?.businessRoleDetails[0]?._id,
                },
              },
            };
            getCreatorsDataFinishingOption();
          }
          setForm(formValues);
        });
      }
    );
  };
  const getCreatorsDataDesignerOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c62fe",
      },
      (res: any) => {
        designerOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "NAQSEBAND") {
            designerOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataWeaverOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c62ff",
      },
      (res: any) => {
        weaverOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "WEAVER") {
            weaverOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataDyingOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: "63c64da18667bd64a57c6300",
      },
      (res: any) => {
        dyerOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (ele?.businessRoleDetails[0]?.role === "DYER") {
            dyerOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCreatorsDataFinishingOption = (name?: any) => {
    props.getUsers(
      {
        offset: 0,
        limit: 10,
        organizationId,
        usersName: name,
        role: [
          "63c64da18667bd64a57c6303",
          "63c64da18667bd64a57c6302",
          "63c64da18667bd64a57c6301",
        ],
      },
      (res: any) => {
        finisherOptions = [];
        res?.data?.docs.map((ele: any) => {
          if (
            ele?.businessRoleDetails[0]?.role === "RAFUGAR" ||
            ele?.businessRoleDetails[0]?.role === "STAIN_MASTER" ||
            ele?.businessRoleDetails[0]?.role === "TASSEL"
          ) {
            finisherOptions.push({
              label: ele?.name,
              value: ele?._id,
            });
          }
        });
      }
    );
  };
  const getCategoryData = (data?: any) => {
    props.getCategory(
      {
        offset: 0,
        limit: 10,
        typeId: form?.type?.value || data?.type,
        artformId: form?.artform?.value || data.artform,
        categoryName: data?.value,
      },
      (res: any) => {
        categoryOptions = [];
        res?.data?.docs.map((ele: any) => {
          categoryOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getTypesData = (data?: any) => {
    props.getTypes(
      {
        offset: 0,
        limit: 10,
        artFormId: form?.artform?.value || data?.artform,
        typeId: form?.type?.value || data?.type,
        typeName: data?.value,
      },
      (res: any) => {
        typeOptions = [];
        res?.data?.docs.map((ele: any) => {
          typeOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getArtformData = (data?: any) => {
    props.getArtforms(
      {
        offset: 0,
        limit: 10,
        artformName: data?.value,
      },
      (res: any) => {
        artformOptions = [];
        res?.data?.docs.map((ele: any) => {
          artformOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };

  const CallingGettProduct = (value: any) => {
    props.getProducts(
      {
        offset: 0,
        limit: 10,
        ProductsName: value?.productName,
        artformId: value?.artform,
        typeId: value?.type,
        categoryId: value?.category,
        subCategoryId: value?.subCategory,
        weaveTypeId: value?.weaveType,
      },
      (res: any) => {
        setLoading(false);
        if (res?.data?.docs?.length) {
          res.data?.docs.map((ele: any, i: any) => {
            if (value.productName.match(ele?.name)) {
              setFilterProduct(ele?.name);
            }
          });
        }
      }
    );
  };
  const callingGetTypesData = (value: any) => {
    props.getTypes(
      {
        offset: 0,
        limit: 1,
        artFormId: value?.artformId,
        typeName: value?.type,
      },
      (res: any) => {
        // let newValues={...filterValue}
        if (res?.data?.docs?.length) {
          res.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              type: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              type: ele?._id,
            });
          });
        }
      }
    );
  };
  const callingGetCategoryData = (value: any) => {
    props.getCategory(
      {
        offset: 0,
        limit: 10,
        typeId: value?.typeId,
        categoryName: value?.category,
        artformId: value?.artformId,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              category: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              category: ele?._id,
            });
          });
        }
      }
    );
  };
  const callingGetSubCategory = (value: any) => {
    props.getSubCategorys(
      {
        offset: 0,
        limit: 1,
        // category:value?.category,
        subCategoryName: value?.subCategory,
        artformId: value?.artformId,
        typeId: value?.typeId,
        categoryId: value?.categoryId,
        subCategoryId: value?.subCategoryId,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              subCategory: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              subCategory: ele?._id,
            });
          });
        }
      }
    );
  };

  const callingGetWeaveType = (value: any) => {
    props.getWeaveType(
      {
        offset: 0,
        limit: 10,
        artformId: value?.artformId,
        typeId: value?.typeId,
        categoryId: value?.categoryId,
        subCategoryId: value?.subCategoryId,
        weaveTypeId: value?.weaveTypeId,
        weaveTypeName: value.weaveType,
      },
      (res: any) => {
        if (res?.data?.docs?.length) {
          res?.data?.docs.map((ele: any, i: any) => {
            setForm({
              ...form,
              weaveType: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
            setFilterValue({
              ...filterValue,
              weaveType: ele?._id,
            });
          });
        }
      }
    );
  };
  useEffect(() => {
    getArtformData();
    getCreatorsDataDesignerOption();
    getCreatorsDataDyingOption();
    getCreatorsDataFinishingOption();
    getCreatorsDataWeaverOption();
  }, []);
  useEffect(() => {
    if (form?.artform?.value?.length) {
      getTypesData();
    }
  }, [form?.artform?.value]);
  useEffect(() => {
    if (form?.type?.value?.length) {
      getCategoryData();
    }
  }, [form?.type?.value]);
  useEffect(() => {
    if (form?.category?.value?.length) {
      getSubCategoryData();
    }
  }, [form?.category?.value]);
  useEffect(() => {
    if (form?.subCategory?.value?.length) {
      getWeaveTypeData();
    }
  }, [form?.subCategory?.value]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexVariant,
      baseImage: baseImageVariant,
      media: form?.variantImages,
      selectedFiles: selectedFileVariant,
      fileArr: fileObjVariant,
      name: "variant",
    });
  }, [deleteIndexVariant]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexDesigner,
      baseImage: baseImageDesigner,
      media: form?.designerMedia,
      selectedFiles: selectedFileDesigner,
      fileArr: fileObjDesign,
      name: "desinging",
    });
  }, [deleteIndexDesigner]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexWeaver,
      baseImage: baseImageWeaver,
      media: form?.weaverMedia,
      selectedFiles: selectedFileWeaver,
      fileArr: fileObjWeaving,
      name: "weaving",
    });
  }, [deleteIndexWeaver]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexDying,
      baseImage: baseImageDying,
      media: form?.dyerMedia,
      selectedFiles: selectedFileDying,
      fileArr: fileObjDying,
      name: "dying",
    });
  }, [deleteIndexDying]);

  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexFinisher,
      baseImage: baseImageFinisher,
      media: form?.finisherMedia,
      selectedFiles: selectedFileFinisher,
      fileArr: fileObjFinishing,
      name: "finishing",
    });
  }, [deleteIndexFinisher]);
  useEffect(() => {
    deleteImagesByIndex({
      deleteIndex: deleteIndexLogo,
      baseImage: baseImageLogo,
      media: form?.profileURL,
      selectedFiles: selectedFile,
      fileArr: fileObjLogo,
      name: "logo",
    });
  }, [deleteIndexLogo]);

  // delete data  reuse function

  const deleteImagesByIndex = (data: any) => {
    let { deleteIndex, baseImage, media, selectedFiles, name, fileArr } = data;
    let deleteBaseImage = baseImage?.length
      ? baseImage.filter((ele: any, i: any) => i !== deleteIndex?.i)
      : [];
    let deleteMedia =
      media?.length && media.filter((ele: any, i: any) => i !== deleteIndex?.i);
    let deletefileArray =
      fileArr?.length &&
      fileArr.filter(
        (ele: any, i: any) => ele?.name !== deleteIndex?.item?.fileName
      );
    let deleteSelectedFile =
      selectedFiles?.length &&
      selectedFiles.filter(
        (ele: any, i: any) => ele?.name !== deleteIndex?.item?.fileName
      );
    if (name === "desinging") {
      fileObjDesign = deletefileArray?.length ? deletefileArray : [];
      setForm({
        ...form,
        designerMedia: deleteMedia,
      });
      setSelectedFileDesigner(deleteSelectedFile);
      setBaseImageDesigner([...deleteBaseImage]);
    } else if (name === "weaving") {
      fileObjWeaving = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileWeaver(deleteSelectedFile);
      setForm({
        ...form,
        weaverMedia: deleteMedia,
      });
      setBaseImageWeaver([...deleteBaseImage]);
    } else if (name === "dying") {
      fileObjDying = deletefileArray?.length ? deletefileArray : [];
      setForm({
        ...form,
        dyerMedia: deleteMedia,
      });
      setBaseImageDying([...deleteBaseImage]);
      setSelectedFileDying(deleteSelectedFile);
    } else if (name === "finishing") {
      fileObjFinishing = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileFinisher(deleteSelectedFile);
      setForm({
        ...form,
        finisherMedia: deleteMedia,
      });
      setBaseImageFinisher([...deleteBaseImage]);
    } else if (name === "variant") {
      fileObjVariant = deletefileArray?.length ? deletefileArray : [];
      setSelectedFileVariant(deleteSelectedFile);
      setForm({
        ...form,
        variantImages: deleteMedia,
      });
      setBaseImageVariant([...deleteBaseImage]);
    }
    if (name === "logo") {
      fileObjLogo = deletefileArray?.length ? deletefileArray : [];
      setSelectedFile(deleteSelectedFile);
      setForm({
        ...form,
        profileURL: deleteMedia,
      });
      setBaseImageLogo([...deleteBaseImage]);
    }
  };
  // Saving a draft needs only a name and colour; artform, type, category, sub-category and
  // weave type are needed to publish.
  const validate = (publishing = false) => {
    let error = "";
    let err = Error;

    if (publishing && (form?.artform === "" || !masterIdFromRef(form?.artform))) {
      error = "Required";
      err = {
        ...err,
        artform: "ArtForm is Required!",
      };
    }
    if (publishing && (form?.type === "" || !masterIdFromRef(form?.type))) {
      error = "Required";
      err = {
        ...err,
        type: "Type Name is Required!",
      };
    }
    if (publishing && (form?.category === "" || !masterIdFromRef(form?.category))) {
      error = "Required";
      err = {
        ...err,
        category: "Category Name is Required!",
      };
    }
    if (publishing && (form?.subCategory === "" || !masterIdFromRef(form?.subCategory))) {
      error = "Required";
      err = {
        ...err,
        subCategory: "Sub-Category Name is Required!",
      };
    }
    if (publishing && (weaveTypeApplicable && (form?.weaveType === "" || !masterIdFromRef(form?.weaveType)))) {
      error = "Required";
      err = {
        ...err,
        weaveType: "Weave Type is Required!",
      };
    }
    if (form?.productName === "") {
      error = "Required";
      err = {
        ...err,
        product: "Product Name is Required!",
      };
    }
    if (form?.variantCode === "") {
      error = "Required";
      setError({
        ...Error,
      });
      err = {
        ...err,
        variantCode: "Color Name is Required!",
      };
    }
    setError(err);
    return error;
  };
  const validateForVariant = () => {
    let error = "";
    let err = ErrorForVariant;
    if (variantForm?.variantCode === "") {
      error = "Required";
      err = {
        ...err,
        color: "Color Name is Required!",
      };
    }
    setErrorForVariant(err);
    return error;
  };
  const s3UploadDesigningBatch = async (files: File[]) => {
    const out: { status: number; url: string }[] = [];
    for (let i = 0; i < files.length; i++) {
      let fileType: any = files[i]?.type;
      if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        fileType = "application/docx";
      } else if (fileType === "application/msword") {
        fileType = "application/doc";
      }
      await new Promise<void>((resolve) => {
        props.fetchProductDesigningPresignedUrl({ fileType }, (res: any) => {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", files[i].type);
          props.uploadImages1(res.data, files[i], myHeaders, (resServer: any) => {
            const st = resServer?.status;
            out.push({
              status: st,
              url: (resServer?.url || "").split("?")[0],
            });
            allStatusCodes.push(st);
            resolve();
          });
        });
      });
    }
    return out;
  };

  const onFlexFilesPicked = (slotKey: string, files: File[]) => {
    setFlexUploadDirty(true);
    const draftOn = isProductDraftRevisionsEnabled() && (form?.id || ProductId);
    if (draftOn) {
      const added = files.filter(Boolean).map((file) => ({
        type: file.type,
        blobImage: URL.createObjectURL(file),
        fileName: file.name,
        show: true,
        _local: true,
        mediaId: newMediaId(),
        uploadStatus: "QUEUED",
        uploadProgress: 0,
      }));
      if (!added.length) {
        return;
      }
      setForm((f: any) => ({
        ...f,
        flexUploadSlots: f.flexUploadSlots.map((s: any) =>
          s.key === slotKey ? { ...s, baseImages: [...(s.baseImages || []), ...added] } : s
        ),
      }));
      void (async () => {
        const slot = (flexSlotsRef.current || []).find((s: any) => s.key === slotKey);
        for (let i = 0; i < files.length; i += 1) {
          const row = added[i];
          if (!row?.mediaId) {
            continue;
          }
          await enqueueProductMedia({
            file: files[i],
            mediaId: row.mediaId,
            productId: form?.id || ProductId,
            section: "flexible",
            processTitle: slot?.title || "",
            productProcessId: slot?.productProcessId || "",
            show: 1,
          });
        }
      })();
      return;
    }
    setFlexPendingFiles((prev) => ({
      ...prev,
      [slotKey]: [...(prev[slotKey] || []), ...files],
    }));
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: f.flexUploadSlots.map((s: any) => {
        if (s.key !== slotKey) return s;
        const added = files.map((file) => ({
          type: file.type,
          blobImage: URL.createObjectURL(file),
          fileName: file.name,
          show: true,
          _local: true,
        }));
        return { ...s, baseImages: [...(s.baseImages || []), ...added] };
      }),
    }));
  };

  const onFlexDeletePreview = (slotKey: string, index: number) => {
    onFlexDeleteMany(slotKey, [index]);
  };

  const onFlexDeleteMany = (slotKey: string, indexes: number[]) => {
    setFlexUploadDirty(true);
    setForm((f: any) => ({
      ...f,
      flexUploadSlots: f.flexUploadSlots.map((s: any) => {
        if (s.key !== slotKey) return s;
        const removed = mediaItemsAtVisibleIndexes(s.baseImages, indexes);
        const nextImgs = dropMediaItems(s.baseImages, removed);
        removed.forEach((item: any) => {
          if (item?.mediaId) {
            void cancelProductMedia(item.mediaId);
          }
          if (item?.mediaId && isProductDraftRevisionsEnabled() && (form?.id || ProductId)) {
            void deleteDraftMedia(form?.id || ProductId, item.mediaId);
          }
        });
        const localNames = removed
          .filter((item: any) => item?._local && item.fileName)
          .map((item: any) => item.fileName);
        if (localNames.length) {
          setFlexPendingFiles((prev) => ({
            ...prev,
            [slotKey]: (prev[slotKey] || []).filter((file) => !localNames.includes(file.name)),
          }));
        }
        return { ...s, baseImages: nextImgs };
      }),
    }));
  };

  const onFlexToggleShow = (slotKey: string, index: number, show: boolean) => {
    setFlexUploadDirty(true);
    setForm((f: any) => {
      const slot = (f.flexUploadSlots || []).find((s: any) => s.key === slotKey);
      const item = slot?.baseImages?.[index];
      if (item?.mediaId && isProductDraftRevisionsEnabled() && (f?.id || ProductId)) {
        void patchDraftMedia(f?.id || ProductId, item.mediaId, { show: show ? 1 : 0 });
      }
      return {
        ...f,
        flexUploadSlots: f.flexUploadSlots.map((s: any) => {
          if (s.key !== slotKey) return s;
          const imgs = [...s.baseImages];
          if (imgs[index]) imgs[index] = { ...imgs[index], show };
          return { ...s, baseImages: imgs };
        }),
      };
    });
  };

  const handleSubmit = async (status: any, kind: "save" | "publish" = "save") => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    handedOffRef.current = false;
    setSaving(kind);
    try {
      await runSubmit(status);
    } finally {
      // callingUpdateProduct releases from its callback once it has taken over. Any early return
      // (validation, missing id, an upload error) must not leave the next Save thinking it is quiet.
      if (!handedOffRef.current) {
        stayAfterSaveRef.current = false;
        releaseSubmit();
      }
    }
  };
  const runSubmit = async (status: any) => {
    let result: any = validate(status?.status === 1);
    if (result?.length !== 0 && stayAfterSaveRef.current) {
      // A step change never stops on red fields; Save draft / Publish still show them.
      stayAfterSaveRef.current = false;
      return;
    }
    if (result?.length !== 0) {
      notifications({
        title: "Error!",
        message: "Some required fields are empty. They are marked in red.",
        type: "danger",
      });
      // On phones the buttons are far below the fields, so take the user to the first error.
      window.setTimeout(() => {
        // Category errors sit in the level-by-level selects: open them so the red text is visible.
        setLevelsOpen(true);
        window.setTimeout(() => {
          const first = document.querySelector(".RequiredField");
          openStepFor(first);
          window.setTimeout(() => first?.scrollIntoView({ block: "center" }), 50);
        }, 0);
      }, 150);
      return;
    }
    // Owner rule: a piece goes live only with a photo buyers can see (the server checks too).
    // Older live pieces that never had one may still publish other edits.
    const firstPublish = status?.status === 1 && isDraftStatus(form?.status);
    const liveHadPhoto = Boolean(pickEditorCoverUrl(rawLiveProduct?.thumbnailDetails?.media));
    if ((firstPublish || (status?.publishDraft && liveHadPhoto)) && !pickEditorCoverUrl(baseImageLogo)) {
      notifications({
        title: "Add a photo first",
        message: "A piece goes live only with at least one photo buyers can see. You can keep it as a draft.",
        type: "danger",
      });
      goToStep("photos");
      return;
    }
    if (status?.status === 1 && (status?.publishDraft || isDraftStatus(form?.status))) {
      const [productRes, processRes] = await Promise.all([
        getOrganizationTaxonomyConfig("PRODUCT"), getOrganizationTaxonomyConfig("PROCESS"),
      ]);
      if (productRes.success) setProductTaxonomyFields(productRes.data || []);
      if (processRes.success) setProcessTaxonomyFields(processRes.data || []);
      const missing = productRes.success && processRes.success
        ? collectMissingPublishFields(productRes.data || [], form?.taxonomyValues,
            processRes.data || [], form.flexUploadSlots || [], processMasterOptions)
        : [];
      if (!productRes.success || !processRes.success) setTaxonomyConfigError(customFieldsCopy.configLoadWarning);
      if (missing.length) {
        setMissingPublishFields(missing);
        openStepFor(document.getElementById(missing[0]?.focusId || "hkp-product-attributes"));
        window.setTimeout(() => document.getElementById("ps-missing")?.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
        return;
      }
    }
    setMissingPublishFields([]);
    const productMongoId = mongoIdForProductUpdate(form, location?.state);
    if (!productMongoId) {
      notifications({
        title: "Error!",
        message: "Could not find this product to save. Reload Edit Product and try again.",
        type: "danger",
      });
      return;
    }
    if (result?.length === 0) {
      const draftOn = isProductDraftRevisionsEnabled();
      const publishDraftNow = Boolean(status?.publishDraft);
      const publishingLive =
        publishDraftNow || (status?.status === 1 && isDraftStatus(form?.status));
      if (draftOn && publishingLive) {
        const summary = summarizeUploads(form?.id || ProductId, visibleMediaIds);
        if (summary.unresolved > 0) {
          notifications({
            title: "Uploads in progress",
            message: "Wait for required media uploads to finish, or retry failed ones.",
            type: "danger",
          });
          return;
        }
      }
      let flexSlots = JSON.parse(JSON.stringify(flexSlotsRef.current || []));
      const pendingLogoFiles = draftOn ? [] : collectUniqueFiles([], selectedFile);
      if (pendingLogoFiles.length > 0) {
        setLoader(true);
        const resultForLogo: any = await S3UploadForLogo(pendingLogoFiles);

        resultForLogo?.length > 0 &&
          resultForLogo.forEach((ele: any, i: any) => {
            promiseLogoStatusCode.push(ele?.statusCode);
            allStatusCodes.push(ele?.statusCode);
            if (ele?.statusCode === 200) {
              promiseLogoUrl.push({
                mediaUrl: ele?.url,
                show:
                  baseImageLogo[
                    form?.profileURL?.length > 0
                      ? form?.profileURL?.length
                      : 0 + i
                  ]?.show === true
                    ? 1
                    : 0,
                pin:
                  baseImageLogo[
                    form?.profileURL?.length > 0
                      ? form?.profileURL?.length
                      : 0 + i
                  ]?.pin === true
                    ? 1
                    : 0,
              });
            }
          });
        promiseLogoStatusCode.map((ele: any, i: any) => {
          if (ele === 200) {
          } else {
            notifications({
              title: "Error!",
              message: `Media ${Number(
                form?.profileURL?.length > 0 ? form?.profileURL?.length : 0
              ) +
                i +
                1
                } upload failed into server under logo section !`,
              type: "danger",
            });
          }
        });
        setBaseImageLogo((prev: any[]) =>
          replaceLocalPreviewsWithUploaded(prev, resultForLogo || [], pendingLogoFiles)
        );
        const failedLogo = pendingLogoFiles.filter(
          (_, i) => resultForLogo?.[i]?.statusCode !== 200
        );
        fileObjLogo = failedLogo;
        setSelectedFile(failedLogo);
        setLoader(false);
      }
      const flexPending = draftOn
        ? false
        : flexSlots.some((slot: any) =>
            collectUniqueFiles([], flexPendingFiles[slot.key]).length > 0
          );
      if (flexPending) {
        setLoader(true);
      }
      const nextFlexPending: Record<string, File[]> = { ...flexPendingFiles };
      for (const slot of flexSlots) {
        const pending = collectUniqueFiles([], flexPendingFiles[slot.key]);
        if (pending.length) {
          const uploaded = await s3UploadDesigningBatch(pending);
          slot.baseImages = replaceLocalPreviewsWithUploaded(
            slot.baseImages,
            uploaded,
            pending
          );
          const failed = pending.filter((_, i) => uploaded[i]?.status !== 200);
          if (failed.length) {
            nextFlexPending[slot.key] = failed;
          } else {
            delete nextFlexPending[slot.key];
          }
        }
      }
      setFlexPendingFiles(nextFlexPending);
      if (flexPending) {
        setLoader(false);
      }

      const flexPayload = flexSlotsToPayloadProcesses(flexSlots);
      const pickMedia = (i: number) => {
        const m = flexPayload[i]?.media;
        return m?.length ? m : [{ mediaUrl: "", show: 0 }];
      };
      const pickKarigar = (i: number) => masterIdFromRef(flexSlots[i]?.artisan);
      const shouldSubmitFlexibleProcesses =
        isFlexibleProcessWorkflow(form) ||
        flexUploadDirty ||
        flexSlots.some((s: any) => String(s?.productProcessId || "").trim());

      const thumbnailMedia = persistableThumbnailRows([
        ...promiseLogoUrl,
        ...(Array.isArray(baseImageLogo) ? baseImageLogo : []),
      ]);
      setForm((current: any) => ({
        ...current,
        profileURL: thumbnailMedia,
        flexUploadSlots: flexSlots,
      }));

      let payload: any = {
        id: productMongoId,
        mediaViewsSkipped: normalizeSkipped(form?.mediaViewsSkipped),
        name: form?.productName,
        xuid: form?.xuid?.length ? form?.xuid.trim() : "",
        tags: form?.tags,
        ...(Array.isArray(form?.typeTagIds) ? { typeTagIds: form.typeTagIds } : {}),
        thumbnails: {
          media: mediaForProductWrite(thumbnailMedia, true),
        },
        ...masterIdsForProductWrite(form),
        // associationId: "",
        designing: {
          media: mediaForProductWrite(pickMedia(0)),
          karigarId: pickKarigar(0),
        },
        weaving: {
          media: mediaForProductWrite(pickMedia(1)),
          karigarId: pickKarigar(1),
        },
        dying: {
          media: mediaForProductWrite(pickMedia(2)),
          karigarId: pickKarigar(2),
        },
        finishing: {
          media: mediaForProductWrite(pickMedia(3)),
          karigarId: pickKarigar(3),
        },
        status: status?.status,
        color: form?.variantCode,
        description: form?.description || "",
        //new
        brand: form?.nameOfBrand,
        weaver: form?.nameOfWeaver,
        handloom: form?.handloomMark,
        silk: form?.silkMark,
        zari: form?.zariUsed?.label === "None" ? "" : form?.zariUsed?.label,
        sareeWeight: form?.weightOfSaree,
        zariWeight: form?.weightOfZariUsed,
        purity: form?.zariUsed?.value,
        madeIn: "true",
        yarnType: form?.yarnType?.label ? form?.yarnType?.label : "",
        workingHours: form?.workingHours,
        loomNum: form?.loomNum,
        // new
        srNo: form?.SrNo,
        orgSrNo: parseOrgSrNo(form?.orgSrNo),
        weavingCenter: form?.weavingCenter,
        giId: form?.giId || undefined,
        typeOfSareeByDesign: form?.typeOfSareeByDesign?.label,
        productionTimeInMonths: form?.productionTimeInMonths?.label,
        sellPrice: form?.sellPrice,
        costPrice: form?.costPrice,
        inStock: form?.inStock === true,
        designNum: form?.designNum,
        processSteps: serializeProcessStepsForApi(form?.processSteps),
        productOwner: form?.productOwner,
        designOwner: form?.designOwner,
        taxonomyValues: mergeTaxonomyValues(
          form?.taxonomyValues,
          form?.taxonomyValues,
          productTaxonomyFields.map((field) => field.taxonomyId)
        ),
      };
      if (shouldSubmitFlexibleProcesses) {
        payload.processWorkflowVersion = "flexible";
        if (flexPayload.length !== flexSlots.length) {
          notifications({
            title: "Error!",
            message: "Process list could not be prepared for save. Reload Edit Product and try again.",
            type: "danger",
          });
          return;
        }
        payload.flexibleUploadProcesses = flexPayload.map((process: any) => ({
          ...process,
          media: mediaForProductWrite(process.media),
        }));
      }
      const uploadHadFailures =
        allStatusCodes.length > 0 && !allStatusCodes.every((ele: any) => ele === 200);
      const afterSave =
        isProductDraftRevisionsEnabled() &&
        Boolean(status?.publishDraft) &&
        !isDraftStatus(form?.status)
          ? async () => {
              const pub = await publishProductDraft(form?.id || ProductId);
              if (!pub?.success) {
                throw pub;
              }
            }
          : undefined;
      if (uploadHadFailures) {
        callingUpdateProduct(payload, "Kindly edit and add the media again !", afterSave);
      } else {
        callingUpdateProduct(payload, undefined, afterSave);
      }
    }
  };
  const resetVariables = () => {
    // selector options
    artformOptions = [];
    typeOptions = [];
    categoryOptions = [];
    designerOptions = [];
    weaverOptions = [];
    dyerOptions = [];
    finisherOptions = [];
    subCategoryOptions = [];
    weaveTypeOptions = [];

    // logo
    fileObjLogo = [];
    fileArrayLogo = [];
    promiseForLogo = [];
    promiseLogoUrl = [];
    promiseLogoStatusCode = [];

    // designing
    fileObjDesign = [];
    fileArray = [];
    promiseForDesign = [];
    promiseDesignUrl = [];
    promiseDesignStatusCode = [];
    // weaving
    fileObjWeaving = [];
    fileArrayWeaving = [];
    promiseForWeaving = [];
    proWeavingUrl = [];
    proWeavingCodes = [];
    // dying
    fileObjDying = [];
    fileArrayDying = [];
    promiseForDying = [];
    proDyingUrl = [];
    proDyingCodes = [];
    // finishing
    fileObjFinishing = [];
    fileArrayFinishing = [];
    promiseForFinishing = [];
    proFinishingUrl = [];
    proFinishingUCodes = [];
    // variant
    fileObjVariant = [];
    fileArrayVariant = [];
    promiseForVariant = [];
    promiseVariantUrl = [];
    promiseVariantStatusCode = [];

    allStatusCodes = [];
    fileObjImages = [];
    // uniqueArr = [];

    productMainImageStatusCode = [];
  };
  const callingUpdateProduct = (payload: any, msg?: any, afterSave?: () => Promise<void>) => {
    // let result: any = validate();
    // if (result?.length === 0) {
    // Keep the form mounted while saving; the buttons show progress instead.
    handedOffRef.current = true;
    props.updateProducts(payload, async (res: any) => {
      if (res.success && afterSave) {
        try {
          await afterSave();
        } catch (error) {
          releaseSubmit();
          if (await showRequiredFields(error)) return;
          notifications({
            title: "Error!",
            message: "Saved draft but could not publish changes",
            type: "danger",
          });
          return;
        }
      }
      releaseSubmit();
      const stay = stayAfterSaveRef.current;
      stayAfterSaveRef.current = false;
      if (res.success && stay) {
        quietGate.sent();
        setAutoSavedAt(Date.now());
      } else if (res.success) {
        // The list shows its own short "Saved as draft" / "Published" note and highlights this piece.
        history.push("/products", {
          savedProduct: {
            productUniqueId: form?.productUniqueId || ProductId,
            name: form?.productName,
            status: isDraftStatus(form?.status) && payload?.status !== 1 ? "drafted" : "published",
          },
        });
      } else if (parseCustomFieldsRequired(res).length) {
        await showRequiredFields(res);
      } else if (res?.status === 400) {
        notifications({
          title: "Error!",
          message: res?.detail || res?.message || "Could not save this product.",
          type: "danger",
        });
      } else {
        notifications({
          title: "Error!",
          message: res?.message,
          type: "danger",
        });
      }
      resetVariables();
      //logo
      fileObjLogo = [];
      fileArrayLogo = [];
      promiseForLogo = [];
      promiseLogoUrl = [];
      promiseLogoStatusCode = [];

      fileObjDesign = [];
      fileObjDying = [];
      fileObjFinishing = [];
      fileObjWeaving = [];
      fileObjVariant = [];
      allStatusCodes = [];
      proFinishingUCodes = [];
      proDyingCodes = [];
      promiseDesignStatusCode = [];
      proWeavingCodes = [];
      proDyingUrl = [];
      proWeavingUrl = [];
      promiseDesignUrl = [];
      proFinishingUrl = [];
      promiseForDesign = [];
      promiseForDying = [];
      promiseForFinishing = [];
      promiseForWeaving = [];
      promiseForVariant = [];
      promiseVariantUrl = [];
      promiseVariantStatusCode = [];
      fileArrayVariant = [];
      // uniqueArr = [];
    });
    // }
  };
  const handleOnInputChange = (type: any) => {
    setHandleNameFlag({
      designing: false,
      weaving: false,
      dying: false,
      finishing: false,
    });
    let formValues = form;
    if (type?.name === "artform") {
      formValues = {
        ...formValues,
        type: "",
        category: "",
        subCategory: "",
        weaveType: "",
        artform: type?.value,
      };
    } else if (type?.name === "type") {
      formValues = {
        ...formValues,
        type: type?.value,
        category: "",
        subCategory: "",
        weaveType: "",
      };
    } else if (type?.name === "category") {
      formValues = {
        ...formValues,
        category: type?.value,
        subCategory: "",
        weaveType: "",
      };
    } else if (type?.name === "subCategory") {
      formValues = {
        ...formValues,
        subCategory: type?.value,
        weaveType: "",
      };
    } else if (type?.name === "weaveType") {
      formValues = {
        ...formValues,
        weaveType: type?.value,
      };
    } else {
      if (
        authUser?.users?.organizationResponse?.name ===
        "tantuvi by smriti morarka" &&
        type?.name === "typeOfSareeByDesign"
      ) {
        formValues = {
          ...formValues,
          productName: type?.value?.value,
          typeOfSareeByDesign: type?.value,
        };
      } else if (type?.name === "timeTakenInMonths") {
        formValues = {
          ...formValues,
          workingHours: type?.value?.value,
          productionTimeInMonths: type?.value,
        };
      } else {
        formValues = {
          ...formValues,
          [type.name]: type?.value,
        };
      }
    }
    setForm(formValues);
    setFilterValue({
      type: "",
      category: "",
      subCategory: "",
      weaveType: "",
    });
  };
  // useEffect(() => {
  //   if (selectedFile) {
  //     S3Upload();
  //   }
  // }, [selectedFile]);

  const gettingFileType = (file: any) => {
    let fileType: any;
    if (
      file ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      fileType = "application/docx";
    } else if (file === "application/msword") {
      fileType = "application/doc";
    } else {
      fileType = file;
    }
    return fileType;
  };
  // S3 upload into awd
  const S3UploadVariants = async () => {
    let softCopyArry: any = [];
    for (let i = 0; i < selectedFileVariant?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileVariant[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductDesigningPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(
              selectedFileVariant[i],
              selectedFileVariant[i].name
            );
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileVariant[i].type);
            props.uploadImages1(
              res.data,
              selectedFileVariant[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArry.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArry);
              }
            );
          }
        );
      });
      promiseForVariant.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForVariant);
    return t[0];
  };
  const S3UploadForLogo = async (files?: File[]) => {
    const toUpload = collectUniqueFiles([], files || selectedFile || []);
    promiseForLogo = [];
    const softCopyArry: { statusCode?: number; url?: string }[] = new Array(toUpload.length);

    await Promise.all(
      toUpload.map(
        (file, i) =>
          new Promise<void>((resolve) => {
            const fileType = gettingFileType(file.type);
            props.fetchProfilePresignedUrl({ fileType: fileType }, (res: any) => {
              const myHeaders = new Headers();
              myHeaders.append("Content-Type", file.type);
              props.uploadImages1(res.data, file, myHeaders, (resSerever: any) => {
                softCopyArry[i] = {
                  statusCode: resSerever?.status,
                  url: (resSerever?.url || "").split("?")[0],
                };
                resolve();
              });
            });
          })
      )
    );
    return softCopyArry;
  };
  const S3UploadDesigner = async () => {
    let softCopyArry: any = [];
    for (let i = 0; i < selectedFileDesigner?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileDesigner[i]?.type);

      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductDesigningPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(
              selectedFileDesigner[i],
              selectedFileDesigner[i].name
            );
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileDesigner[i].type);
            props.uploadImages1(
              res.data,
              selectedFileDesigner[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArry.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArry);
              }
            );
          }
        );
      });
      promiseForDesign.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForDesign);
    return t[0];
  };
  const S3UploadDying = async () => {
    let softCopyArryForDying: any = [];
    for (let i = 0; i < selectedFileDying?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileDying[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductDyingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(selectedFileDying[i], selectedFileDying[i].name);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileDying[i].type);
            props.uploadImages1(
              res.data,
              selectedFileDying[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArryForDying.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryForDying);
              }
            );
          }
        );
      });
      promiseForDying.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForDying);
    return t[0];
  };
  const S3UploadFinishing = async () => {
    let softCopyArryFinishing: any = [];
    for (let i = 0; i < selectedFileFinisher?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileFinisher[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductFinishingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(
              selectedFileFinisher[i],
              selectedFileFinisher[i].name
            );
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileFinisher[i].type);
            props.uploadImages1(
              res.data,
              selectedFileFinisher[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArryFinishing.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryFinishing);
              }
            );
          }
        );
      });
      promiseForFinishing.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForFinishing);
    return t[0];
  };
  const S3UploadWeaving = async () => {
    let softCopyArryWeaving: any = [];
    for (let i = 0; i < selectedFileWeaver?.length; i++) {
      let fileType: any;
      fileType = gettingFileType(selectedFileWeaver[i]?.type);
      const promise = new Promise((resolve: any, reject: any) => {
        props.fetchProductWeavingPresignedUrl(
          { fileType: fileType },
          (res: any) => {
            const formData = new FormData();
            formData.append(selectedFileWeaver[i], selectedFileWeaver[i].name);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", selectedFileWeaver[i].type);
            props.uploadImages1(
              res.data,
              selectedFileWeaver[i],
              myHeaders,
              (resSerever: any) => {
                softCopyArryWeaving.push({
                  statusCode: resSerever?.status,
                  url: resSerever?.url.split("?")[0],
                });
                resolve(softCopyArryWeaving);
              }
            );
          }
        );
      });
      promiseForWeaving.push(promise);
    }
    let t: any = [];
    t = await Promise.all(promiseForWeaving);
    return t[0];
  };

  // file upload method start reuseable function
  const uploadFiles = (data: any) => {
    let { fileObject, name, files, view } = data;
    if (!files?.length) {
      return;
    }
    const uniqueArr = collectUniqueFiles(fileObject, files);
    if (name === "designing") {
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageDesigner,
      });
      setSelectedFileDesigner(uniqueArr);
      fileObjDesign = uniqueArr;
    } else if (name === "dying") {
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageDying,
      });
      setSelectedFileDying(uniqueArr);
      fileObjDying = uniqueArr;
    } else if (name === "weaving") {
      setSelectedFileWeaver(uniqueArr);
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageWeaver,
      });
      fileObjWeaving = uniqueArr;
    } else if (name === "finishing") {
      setSelectedFileFinisher(uniqueArr);
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageFinisher,
      });
      fileObjFinishing = uniqueArr;
    } else if (name === "variant") {
      setSelectedFileVariant(uniqueArr);
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageVariant,
      });
      fileObjVariant = uniqueArr;
    } else if (name === "logo") {
      setSelectedFile(uniqueArr);
      uploadImageArray({
        name,
        uniqueArr,
        baseImage: baseImageLogo,
        view,
      });
      fileObjLogo = uniqueArr;
      if (isProductDraftRevisionsEnabled() && (form?.id || ProductId)) {
        uniqueArr.forEach((file: File) => {
          void enqueueProductMedia({
            file,
            productId: form?.id || ProductId,
            section: "thumbnail",
            show: 1,
            view: view || null,
          }).then((job) => {
            if (!job) {
              return;
            }
            setBaseImageLogo((prev: any[]) =>
              (prev || []).map((img: any) =>
                img.mediaId === job.mediaId ||
                (img.fileName === file.name && img._local && !img.mediaId)
                  ? {
                      ...img,
                      mediaId: job.mediaId,
                      uploadStatus: job.status,
                      uploadProgress: job.progress,
                      uploadError: job.error,
                    }
                  : img
              )
            );
          });
        });
      }
    }
  };
  // base image reuseable function
  const uploadImageArray = async (data: any) => {
    let { name, uniqueArr, baseImage, view } = data;
    const merged = mergePersistedWithLocalPreviews(
      baseImage,
      uniqueArr,
      name === "logo"
        ? {
            pin: false,
            view: view || null,
            ...(isProductDraftRevisionsEnabled() && (form?.id || ProductId)
              ? { uploadStatus: "QUEUED" }
              : {}),
          }
        : undefined
    );
    if (name === "designing") {
      setBaseImageDesigner(merged);
    } else if (name === "dying") {
      setBaseImageDying(merged);
    } else if (name === "weaving") {
      setBaseImageWeaver(merged);
    } else if (name === "finishing") {
      setBaseImageFinisher(merged);
    } else if (name === "variant") {
      setBaseImageVariant(merged);
    } else if (name === "logo") {
      setBaseImageLogo(merged);
    }
  };
  const addChip = (value: any) => {
    const chips = form.tags.slice();
    chips.push(value);
    setForm({
      ...form,
      tags: chips,
    });
  };
  const removeChip = (index: any) => {
    const chips = form.tags.slice();
    chips.splice(index, 1);
    setForm({
      ...form,
      tags: chips,
    });
  };
  const handleDeleteFinisher = (i: any, item: any) => {
    setDeleteIndexFinisher({
      i,
      item,
    });
  };
  const handleDeleteWeaver = (i: any, item: any) => {
    setDeleteIndexWeaver({
      i,
      item,
    });
  };
  const handleDeleteDying = (i: any, item: any) => {
    setDeleteIndexDying({
      i,
      item,
    });
  };
  const handleDeleteDesigner = (i: any, item: any) => {
    setDeleteIndexDesigner({
      i,
      item,
    });
  };
  const handleDeleteLogo = (i: any, item: any) => {
    if (item?.mediaId) void cancelProductMedia(item.mediaId);
    removedRowRef.current = item;
    if (item?.mediaId && isProductDraftRevisionsEnabled() && (form?.id || ProductId)) {
      void deleteDraftMedia(form?.id || ProductId, item.mediaId);
    }
    setDeleteIndexLogo({
      i,
      item,
    });
  };
  const handleDeleteVariant = (i: any, item: any) => {
    setDeleteIndexVariant({
      i,
      item,
    });
  };
  /** Tag a photo with its view; a saved draft row is patched right away, local rows carry it to the save. */
  const onSetPhotoView = (index: number, view: string | null) => {
    markEdited();
    const row = baseImageLogo?.[index];
    setBaseImageLogo((prev: any[]) =>
      (prev || []).map((img: any, i: number) => (i === index ? { ...img, view: view || undefined } : img))
    );
    if (!row?.mediaId) return;
    if (row._local) {
      // Still uploading: the job saves the draft row, so it must carry the tag.
      void setProductMediaView(row.mediaId, view);
    } else if (isProductDraftRevisionsEnabled() && (form?.id || ProductId)) {
      void patchDraftMedia(form?.id || ProductId, row.mediaId, { view: view || "" });
    }
  };
  /** "This piece has no blouse": a studio hint saved with the product, never shown to buyers. */
  const onSkipPhotoView = (view: string, skipped: boolean) => {
    markEdited();
    setForm((f: any) => {
      const current: string[] = Array.isArray(f?.mediaViewsSkipped) ? f.mediaViewsSkipped : [];
      return {
        ...f,
        mediaViewsSkipped: skipped ? Array.from(new Set([...current, view])) : current.filter((v) => v !== view),
      };
    });
  };
  const onSetPin = (type: any) => {
    markEdited();
    setBaseIndexForLogo(type);
  };
  useEffect(() => {
    // if (baseindexForLogo?.length) {
    if (baseImageLogo?.length) {
      let arrayPin: any = [];
      let arrayPinSelected: any = [];
      let formProfileURL: any = [];
      if (selectedFile?.length > 0) {
        selectedFile.find((ele: any, i: any) => {
          if (i === baseindexForLogo?.index) {
            arrayPinSelected.push(ele);
          } else {
            arrayPinSelected.push(ele);
          }
          setSelectedFile([...arrayPinSelected]);
        });
      }
      baseImageLogo.find((ele: any, i: any) => {
        if (i === baseindexForLogo?.index) {
          arrayPin.push({
            // Keep the upload id, stored link and asset id; only show/pin change.
            ...ele,
            type: ele?.type,
            blobImage: ele?.blobImage,
            fileName: ele?.fileName,
            show: ele?.show,
            pin: true,
          });
          const pinnedUrl =
            persistableMediaUrl(ele?.blobImage) ||
            persistableMediaUrl(form?.profileURL?.[i]?.mediaUrl) ||
            persistableMediaUrl(form?.profileURL?.[i]?.mediaURL);
          if (pinnedUrl) {
            formProfileURL.push({
              mediaUrl: pinnedUrl,
              show: ele?.show === true ? 1 : 0,
              pin: 1,
            });
          }
        } else {
          arrayPin.push({
            // Keep the upload id, stored link and asset id; only show/pin change.
            ...ele,
            type: ele?.type,
            blobImage: ele?.blobImage,
            fileName: ele?.fileName,
            show: ele?.show,
            pin: false,
          });
          const unpinnedUrl =
            persistableMediaUrl(ele?.blobImage) ||
            persistableMediaUrl(form?.profileURL?.[i]?.mediaUrl) ||
            persistableMediaUrl(form?.profileURL?.[i]?.mediaURL);
          if (unpinnedUrl) {
            formProfileURL.push({
              mediaUrl: unpinnedUrl,
              show: ele?.show === true ? 1 : 0,
              pin: 0,
            });
          }
        }

        setBaseImageLogo([...arrayPin]);
        setForm({
          ...form,
          profileURL: formProfileURL,
        });
      });
    }
    // }
  }, [baseindexForLogo]);
  const handleName = (value: any) => {
    if (value?.name === "artform") {
      props.getArtforms(
        {
          offset: 0,
          limit: 1,
          artformName: value?.artform,
        },
        (res: any) => {
          if (res?.data?.docs?.length) {
            setForm({
              ...form,
              type: "",
              category: "",
              subCategory: "",
              weaveType: "",
              artform: {
                label: res?.data?.docs[0]?.name,
                value: res?.data?.docs[0]?._id,
              },
            });
          }
        }
      );
    }
    if (value?.name === "type") {
      callingGetTypesData({
        artformId: value?.artform,
        type: value?.type,
      });
    }
    if (value?.name === "category") {
      callingGetCategoryData({
        typeId: value?.type,
        category: value?.category,
      });
    }
    if (value?.name === "subCategory") {
      callingGetSubCategory({
        categoryId: value?.category,
        subCategory: value?.subCategory,
      });
    }
    if (value?.name === "weaveType") {
      callingGetWeaveType({
        subCategoryId: value?.subCategory,
        weaveType: value?.weaveType,
      });
    }
    let flag = handleNameFlag;
    if (value.name === "designing") {
      getCreatorsData({
        userId: value?.userId,
        name: "designing",
      });
      flag = {
        ...flag,
        designing: true,
      };
    }
    if (value.name === "weaving") {
      getCreatorsData({
        userId: value?.userId,
        name: "weaving",
      });
      flag = {
        ...flag,
        weaving: true,
      };
    }
    if (value.name === "dying") {
      getCreatorsData({
        userId: value?.userId,
        name: "dying",
      });
      flag = {
        ...flag,
        dying: true,
      };
    }
    if (value.name === "finishing") {
      getCreatorsData({
        userId: value?.userId,
        name: "finishing",
      });
      flag = {
        ...flag,
        finishing: true,
      };
    }
    setHandleNameFlag(flag);
  };
  const handleOpenArtform = () => {
    setOpenModal({
      artform: true,
    });
  };
  const handleOpenType = () => {
    setOpenModal({
      type: true,
    });
  };
  const handleOpenCategory = () => {
    setOpenModal({
      category: true,
    });
  };
  const handleOpenSubCategory = () => {
    setOpenModal({
      subCategory: true,
    });
  };
  const handleOpenWeaveType = () => {
    setOpenModal({
      weaveType: true,
    });
  };
  const handleOpenVariant = () => {
    setOpenModal({
      variant: true,
    });
  };
  const handleOpenModal = (value: any) => {
    setOpenModal({
      [value?.name]: value?.value,
    });
  };
  const handleChangeDebounce = React.useCallback(
    debounce((data: any) => {
      if (data?.name === "product") {
        CallingGettProduct(data);
      }
      if (data?.name === "artform") {
        getArtformData(data?.value);
      }
      if (data?.name === "type") {
        getTypesData(data);
      }
      if (data?.name === "category") {
        getCategoryData(data);
      }
      if (data?.name === "subCategory") {
        getSubCategoryData(data);
      }
      if (data?.name === "weaveType") {
        getWeaveTypeData(data);
      }
      if (data?.name === "designing") {
        getCreatorsDataDesignerOption(data?.value);
      }
      if (data?.name === "weaving") {
        getCreatorsDataWeaverOption(data?.value);
      }
      if (data?.name === "dying") {
        getCreatorsDataDyingOption(data?.value);
      }
      if (data?.name === "finishing") {
        getCreatorsDataFinishingOption(data?.value);
      }
    }, 1000),
    []
  );
  const closeModal = () => {
    setOpenModal({
      artform: false,
      type: false,
      category: false,
      subCategory: false,
      weaveType: false,
      variant: false,
      designing: false,
      dying: false,
      weaving: false,
      finishing: false,
    });
    setIsOpen(false);
  };
  let allvariantStatusCode: any = [];
  const handleSubmitVariant = async (e: any) => {
    e.preventDefault();
    if (selectedFileVariant?.length > 0) {
      setLoaderVariant({
        ...loaderVariant,
        images: true,
      });
      const resultForVariants: any = await S3UploadVariants();
      resultForVariants.forEach((ele: any) => {
        promiseVariantStatusCode.push(ele?.statusCode);
        allvariantStatusCode.push(ele?.statusCode);
        if (ele?.statusCode === 200) {
          promiseVariantUrl.push(ele?.url);
        }
      });
      promiseVariantStatusCode.map((ele: any, i: any) => {
        if (ele === 200) {
        } else {
          notifications({
            title: "Error!",
            message: `Media ${i + 1
              } upload failed into server under finishing section !`,
            type: "danger",
          });
        }
      });
      setLoaderVariant({
        ...loaderVariant,
        images: false,
      });
    }
    if (allvariantStatusCode?.length > 0) {
      let codes = allvariantStatusCode.every((ele: any) => ele === 200);
      let payload: any = {
        productId: form?.id,
        color: variantForm?.variantCode,
        additionalImages: promiseVariantUrl ? promiseVariantUrl : [],
      };
      if (codes) {
        setLoaderVariant({
          ...loaderVariant,
          submit: true,
        });
        props.createVariantForProduct(payload, (res: any) => {
          setLoaderVariant({
            ...loaderVariant,
            submit: false,
          });
          if (res.success) {
            notifications({
              title: "Success!",
              message: res?.message,
              type: "success",
            });
            closeModal();
            history.push(`/product/${ProductId}`);
          } else {
            notifications({
              title: "Error!",
              message: res?.message,
              type: "danger",
            });
          }
          promiseVariantUrl = [];
          setBaseImageVariant("");
          setSelectedFileVariant("");
          promiseVariantStatusCode = [];
          allvariantStatusCode = [];
          setVariantForm({
            images: "",
            variantCode: "",
          });
          fileObjVariant = [];
          promiseForVariant = [];
        });
      }
    }
  };
  const onSetIndexDesign = (type: any) => {
    markEdited();
    if (type?.name === "designing") {
      setBaseIndex({
        designing: type,
      });
    }
    if (type?.name === "weaving") {
      setBaseIndex({
        weaving: type,
      });
    }
    if (type?.name === "dying") {
      setBaseIndex({
        dying: type,
      });
    }
    if (type?.name === "finishing") {
      setBaseIndex({
        finishing: type,
      });
    }
    if (type?.name === "logo") {
      setBaseIndex({
        logo: type,
      });
    }
  };
  useEffect(() => {
    if (baseindex?.finishing) {
      if (baseindex?.finishing?.index <= form?.finisherMedia?.length - 1) {
        let media = {
          mediaUrl: form?.finisherMedia[baseindex?.finishing?.index]?.mediaUrl,
          show: baseindex?.finishing?.show === true ? 1 : 0,
        };
        form?.finisherMedia &&
          form?.finisherMedia.find((ele: any, i: any) => {
            if (i === baseindex?.finishing?.index) {
              let showmedia = [...form?.finisherMedia];
              showmedia[i] = media;
              setForm({
                ...form,
                finisherMedia: [...showmedia],
              });
            }
          });
      }
      if (baseImageFinisher?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageFinisher[baseindex?.finishing?.index],
          type: baseImageFinisher[baseindex?.finishing?.index]?.type,
          blobImage: baseImageFinisher[baseindex?.finishing?.index]?.blobImage,
          fileName: baseImageFinisher[baseindex?.finishing?.index]?.fileName,
          show: baseindex?.finishing?.show,
        };
        baseImageFinisher.find((ele: any, i: any) => {
          if (i === baseindex?.finishing?.index) {
            let showm = [...baseImageFinisher];
            showm[i] = showImageData;
            setBaseImageFinisher([...showm]);
          }
        });
      }
    }
    if (baseindex?.dying) {
      if (baseindex?.dying?.index <= form?.dyerMedia?.length - 1) {
        let media = {
          mediaUrl: form?.dyerMedia[baseindex?.dying?.index]?.mediaUrl,
          show: baseindex?.dying?.show === true ? 1 : 0,
        };
        form?.dyerMedia &&
          form?.dyerMedia.find((ele: any, i: any) => {
            if (i === baseindex?.dying?.index) {
              let showmedia = [...form?.dyerMedia];
              showmedia[i] = media;
              setForm({
                ...form,
                dyerMedia: [...showmedia],
              });
            }
          });
      }
      if (baseImageDying?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageDying[baseindex?.dying?.index],
          type: baseImageDying[baseindex?.dying?.index]?.type,
          blobImage: baseImageDying[baseindex?.dying?.index]?.blobImage,
          fileName: baseImageDying[baseindex?.dying?.index]?.fileName,
          show: baseindex?.dying?.show,
        };
        baseImageDying.find((ele: any, i: any) => {
          if (i === baseindex?.dying?.index) {
            let showm = [...baseImageDying];
            showm[i] = showImageData;
            setBaseImageDying([...showm]);
          }
        });
      }
    }
    if (baseindex?.weaving) {
      if (baseindex?.weaving?.index <= form?.weaverMedia?.length - 1) {
        let media = {
          mediaUrl: form.weaverMedia[baseindex?.weaving?.index]?.mediaUrl,
          show: baseindex?.weaving?.show === true ? 1 : 0,
        };
        form.weaverMedia &&
          form.weaverMedia.find((ele: any, i: any) => {
            if (i === baseindex?.weaving?.index) {
              let showmedia = [...form.weaverMedia];
              showmedia[i] = media;
              setForm({
                ...form,
                weaverMedia: [...showmedia],
              });
            }
          });
      }
      if (baseImageWeaver?.length) {
        let showImageData = {
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageWeaver[baseindex?.weaving?.index],
          type: baseImageWeaver[baseindex?.weaving?.index]?.type,
          blobImage: baseImageWeaver[baseindex?.weaving?.index]?.blobImage,
          fileName: baseImageWeaver[baseindex?.weaving?.index]?.fileName,
          show: baseindex?.weaving?.show,
        };
        baseImageWeaver.find((ele: any, i: any) => {
          if (i === baseindex?.weaving?.index) {
            let showm = [...baseImageWeaver];
            showm[i] = showImageData;
            setBaseImageWeaver([...showm]);
          }
        });
      }
    }
    if (baseindex?.designing) {
      if (form?.designerMedia?.length > 0) {
        if (baseindex?.designing?.index <= form?.designerMedia?.length - 1) {
          let media = {
            mediaUrl: form.designerMedia[baseindex?.designing?.index]?.mediaUrl,
            show: baseindex?.designing?.show === true ? 1 : 0,
          };
          form.designerMedia &&
            form.designerMedia.find((ele: any, i: any) => {
              if (i === baseindex?.designing?.index) {
                let showmedia = [...form.designerMedia];
                showmedia[i] = media;
                setForm({
                  ...form,
                  designerMedia: [...showmedia],
                });
              }
            });
        }
      }
      if (baseImageDesigner?.length) {
        let showImageData = {
          // ...baseImageDesigner,
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageDesigner[baseindex?.designing?.index],
          type: baseImageDesigner[baseindex?.designing?.index]?.type,
          blobImage: baseImageDesigner[baseindex?.designing?.index]?.blobImage,
          fileName: baseImageDesigner[baseindex?.designing?.index]?.fileName,
          show: baseindex?.designing?.show,
        };
        baseImageDesigner.find((ele: any, i: any) => {
          if (i === baseindex?.designing?.index) {
            let showm = [...baseImageDesigner];
            showm[i] = showImageData;
            setBaseImageDesigner([...showm]);
          }
        });
      }
    }
    if (baseindex?.logo) {
      if (form?.profileURL?.length > 0) {
        if (baseindex?.logo?.index <= form?.profileURL?.length - 1) {
          let media = {
            mediaUrl: form.profileURL[baseindex?.logo?.index]?.mediaUrl,
            show: baseindex?.logo?.show === true ? 1 : 0,
            pin: baseindex?.logo?.pin === true ? 1 : 0,
          };
          form.profileURL &&
            form.profileURL.find((ele: any, i: any) => {
              if (i === baseindex?.logo?.index) {
                let showmedia = [...form.profileURL];
                showmedia[i] = media;
                setForm({
                  ...form,
                  profileURL: [...showmedia],
                });
              }
            });
        }
      }
      if (baseImageLogo?.length) {
        let showImageData = {
          // ...baseImageDesigner,
          // Keep the upload id, stored link and asset id; only show/pin change.
          ...baseImageLogo[baseindex?.logo?.index],
          type: baseImageLogo[baseindex?.logo?.index]?.type,
          blobImage: baseImageLogo[baseindex?.logo?.index]?.blobImage,
          fileName: baseImageLogo[baseindex?.logo?.index]?.fileName,
          show: baseindex?.logo?.show,
          pin: baseindex?.logo?.pin,
        };
        baseImageLogo.find((ele: any, i: any) => {
          if (i === baseindex?.logo?.index) {
            let showm = [...baseImageLogo];
            showm[i] = showImageData;
            setBaseImageLogo([...showm]);
          }
        });
      }
    }
  }, [baseindex]);
  const onChangeVarient = (e: any) => {
    setVariantForm({
      ...variantForm,
      variantCode: e.target.value,
    });
  };
  const handleOnInputChangeFilters = (type: any) => {
    if (type?.name === "designing") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "weaving") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "dying") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "finishing") {
      if (type?.value?.length >= 2 || type?.value?.length == 0) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "artform") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
      if (
        type?.value.length === 0 &&
        !form?.artform?.value &&
        !form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "type") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.artform?.value &&
        !form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
        });
      }
    }
    if (type?.name === "category") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.type?.value &&
        !form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
        });
      }
    }
    if (type?.name === "subCategory") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.category?.value &&
        !form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
        });
      }
    }
    if (type?.name === "weaveType") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
          subCategory: form?.subCategory?.value,
        });
      } else if (
        type?.value.length === 0 &&
        form?.subCategory?.value &&
        !form?.weaveType?.value &&
        !form?.productName
      ) {
        handleChangeDebounce({
          name: type?.name,
          value: type?.value,
          artform: form?.artform?.value,
          type: form?.type?.value,
          category: form?.category?.value,
          subCategory: form?.subCategory?.value,
        });
      }
    }
  };
  const handleReset = (type: any) => {
    if (type?.name === "designing") {
      setForm({
        ...form,
        designer: "",
      });
    }
    if (type?.name === "weaving") {
      setForm({
        ...form,
        weaver: "",
      });
    }
    if (type?.name === "dying") {
      setForm({
        ...form,
        dyer: "",
      });
    }
    if (type?.name === "finishing") {
      setForm({
        ...form,
        finisher: "",
      });
    }
  };
  // Steps: every panel stays mounted; this only changes what is visible.
  const openStepFor = (el: Element | null) => {
    const holder = stepOfElement(el);
    if (holder) setStep(holder);
  };
  // What counts as an edit for the step autosave: typing, selects, file picks, and the button-style
  // pickers (view chips, colour chips, react-select options). Hydration never fires these.
  useEffect(() => {
    const mark = () => markEdited();
    // Photo sheet actions (tag, cover, show/hide, remove) mark themselves in their handlers.
    const onPointerDown = (event: PointerEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest?.(".ps-main [role='radio'], .ps-main [role='option'], .ps-chip-btn, .react-select__option, [id*='-option-']")) mark();
    };
    document.addEventListener("input", mark, true);
    document.addEventListener("change", mark, true);
    document.addEventListener("pointerdown", onPointerDown, true);
    return () => {
      document.removeEventListener("input", mark, true);
      document.removeEventListener("change", mark, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
    };
  }, []);
  // Only drafts save quietly. A live piece saves on Save / Publish alone: whether the server keeps a
  // draft overlay is a backend switch the build cannot see, and a quiet save must never go live.
  // Rows picked a moment ago have no upload id yet, so the upload summary can't see them: count them here.
  const localMediaRows = useMemo(
    () =>
      [...(baseImageLogo || []), ...(form.flexUploadSlots || []).flatMap((slot: any) => slot?.baseImages || [])].filter(
        // A failed upload waits for Retry; it must not hold every later save back.
        (row: any) => row && !row._deleted && row.uploadStatus !== "FAILED" && isLocalMediaItem(row)
      ).length,
    [baseImageLogo, form.flexUploadSlots]
  );
  const mediaInFlight = uploadSummary.unresolved + localMediaRows;
  const quietSave = () => {
    // Busy saving, or photos still uploading (a save now would send the photo list without them): after.
    const decision = quietGate.decide({ isDraft: isDraftStatus(form?.status), busy: submittingRef.current, mediaInFlight });
    if (decision !== "save") return;
    stayAfterSaveRef.current = true;
    void handleSubmit({ status: 0 }, "save");
  };
  useEffect(() => {
    if (quietGate.pending && !submittingRef.current && mediaInFlight === 0) quietSave();
  }, [quietTick, mediaInFlight]);
  // Remove on a photo or video saves once that row is gone from the list (not on any other list change,
  // e.g. an upload finishing first), so leaving right after never brings it back.
  const removedRowRef = useRef<any>(null);
  useEffect(() => {
    const removed = removedRowRef.current;
    if (!removed) return;
    const url = previewMediaUrl(removed);
    const stillThere = (baseImageLogo || []).some(
      (row: any) => row === removed || (removed.mediaId && row?.mediaId === removed.mediaId) || (url && previewMediaUrl(row) === url)
    );
    if (stillThere) return;
    removedRowRef.current = null;
    markEdited();
    quietSave();
  }, [baseImageLogo]);
  const goToStep = (target: ProductStepId) => {
    quietSave();
    setStep(target);
    const params = new URLSearchParams(location?.search || "");
    params.set("step", target);
    history.replace({ pathname: location.pathname, search: `?${params.toString()}`, state: location.state });
    window.scrollTo({ top: 0 });
  };
  const pickCategoryPath = (path: CategoryPath) => {
    setForm((current: any) => ({
      ...current,
      artform: path.artform,
      type: path.type,
      category: path.category,
      subCategory: path.subCategory,
      weaveType: path.weaveType || "",
    }));
  };
  const liveWithDraftRevisions = isProductDraftRevisionsEnabled() && !isDraftStatus(form?.status);
  const reviewMissing = collectMissingPublishFields(
    productTaxonomyFields,
    form?.taxonomyValues,
    processTaxonomyFields,
    form?.flexUploadSlots || [],
    processMasterOptions
  );
  /** Views still missing ("blouse", "video"): good to have on Review and the Publish sheet, never blocking. */
  const missingPhotoViews = missingWords(
    coverageOf(baseImageLogo, viewSlotsFor(form), normalizeSkipped(form?.mediaViewsSkipped)).missing
  );
  const reviewItems = buildReviewItems({
    form,
    photos: baseImageLogo,
    weaveTypeApplicable,
    missingPublishFields: reviewMissing,
    missingViews: missingPhotoViews,
  });
  // "Fill" on a missing custom field: show the missing list (which opens the Making card holding a
  // process field), switch to that field's step, and scroll to it.
  const jumpFromReview = (target: ProductStepId, focusId?: string) => {
    if (!focusId) {
      goToStep(target);
      return;
    }
    flushSync(() => setMissingPublishFields(reviewMissing));
    const field = document.getElementById(focusId);
    if (field) flushSync(() => openStepFor(field));
    else goToStep(target);
    window.setTimeout(() => document.getElementById(focusId)?.scrollIntoView({ behavior: "smooth", block: "center" }), 0);
  };
  // Same cover as the product list: hidden photos and videos are skipped.
  const previewPhoto: string = pickEditorCoverUrl(baseImageLogo);
  // First publish needs a photo buyers can see (server rule); older live pieces without one may republish.
  const needsPhotoToPublish = isDraftStatus(form?.status) && !previewPhoto;

  return (
    <>
      {isOpen && (
        <ProductImagePreView
          {...props}
          openModal={isOpen}
          closeModal={closeModal}
          images={[image]}
          name="editProduct"
        />
      )}
      <CreateUserModal
        {...props}
        openModal={openModal?.designing}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"designing"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.weaving}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"weaving"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.dying}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"dying"}
      />
      <CreateUserModal
        {...props}
        openModal={openModal?.finishing}
        handleOpenModal={handleOpenModal}
        closeModal={closeModal}
        handleName={handleName}
        name="Product"
        modalName={"finishing"}
      />
      <Modal
        isOpen={openModal?.variant}
        toggle={closeModal}
        size="lg"
        fade={false}
        className="OrganizationModal"
      >
        <ModalHeader>
          <div className="Heading">
            <h3>Create Product Variant</h3>
            <ModalCloseIcon {...props} closeModal={closeModal} />
          </div>
        </ModalHeader>
        <ModalBody>
          {loaderVariant?.submit ? (
            <div className="LoaderDivModal">
              <Loader />
            </div>
          ) : (
            <CreateVariant
              {...props}
              variantForm={variantForm}
              baseImageVariant={baseImageVariant}
              fileInputVariant={fileInputVariant}
              fileArrayVariant={fileArrayVariant}
              fileObjVariant={fileObjVariant}
              uploadFiles={uploadFiles}
              fileUploadTriggerVariant={fileUploadTriggerVariant}
              handleDeleteVariant={handleDeleteVariant}
              handleSubmitVariant={handleSubmitVariant}
              onChangeVarient={onChangeVarient}
              Error={ErrorForVariant}
              validateForVariant={validateForVariant}
              loader={loaderVariant?.images}
              loading={loaderVariant?.submit}
            />
          )}
        </ModalBody>
      </Modal>
      <ArtformModal
        {...props}
        openModal={openModal?.artform}
        closeModal={closeModal}
        getAllData={getArtformData}
        handleName={handleName}
      />
      <TypeModal
        {...props}
        openModal={openModal?.type}
        closeModal={closeModal}
        getAllData={getTypesData}
        handleName={handleName}
        form={form}
      />
      <CategoryModal
        {...props}
        openModal={openModal?.category}
        closeModal={closeModal}
        getAllData={getCategoryData}
        handleName={handleName}
        form={form}
      />
      <SubCategoryModal
        {...props}
        openModal={openModal?.subCategory}
        closeModal={closeModal}
        getAllData={getSubCategoryData}
        handleName={handleName}
        form={form}
      />
      <WeaveTypeModal
        {...props}
        openModal={openModal?.weaveType}
        closeModal={closeModal}
        getAllData={getWeaveTypeData}
        handleName={handleName}
        form={form}
      />
      {loading ? (
        <div className="LoaderDiv">
          <Loader />
        </div>
      ) : (
        <div className={`ps-shell${step === "review" || step === "basics" || step === "details" ? " has-aside" : ""}`}>
          <ProductStepHeader
            title={isFreshDraft ? "Add product" : "Edit product"}
            subtitle={`${form?.orgSrNo ? `#${form.orgSrNo} · ` : ""}${isDraftStatus(form?.status) ? "Draft" : "Live"}`}
            step={step}
            onStep={goToStep}
            chip={
              isDraftStatus(form?.status) ? (
                <span className="ps-chip ps-chip--draft">
                  {saving === "save" && !autoSavedAt ? "Saving…" : autoSavedAt || isFreshDraft ? "Draft saved" : "Draft"}
                </span>
              ) : hasDraftChanges ? (
                <span className="ps-chip ps-chip--edits">Live · edits</span>
              ) : (
                <span className="ps-chip">Live</span>
              )
            }
          />
          <main className="ps-main createProduct CreateProductDetails">
            {liveWithDraftRevisions ? (
              <p className="ps-note" style={{ marginBottom: 13 }}>
                This piece is <b>live</b>. Your changes are kept as a <b>draft</b> — buyers, catalogues and the certificate
                keep showing the live version until you press <b>Publish changes</b>.
              </p>
            ) : null}
            {missingPublishFields.length ? (
              // Shown above whichever step is open; its button opens the step (and Making card) holding the field.
              <div
                id="ps-missing"
                style={{ marginBottom: 13 }}
                onClickCapture={() => {
                  const first = missingPublishFields[0];
                  flushSync(() => openStepFor(document.getElementById(first?.focusId || "hkp-product-attributes")));
                }}
              >
                <TaxonomyRequiredSummary fields={missingPublishFields} />
              </div>
            ) : null}
            <div className="form">
              <div className="UserDetailsDiv">
                <ProductStepPanel id="photos" active={step}>
                  <ProductFamilyBar
                    mode="edit"
                    parentId={form?.parentId}
                    productUniqueId={form?.productUniqueId || ProductId}
                    orgSrNo={form?.orgSrNo}
                    onChanged={getAllData}
                  />
                  <div className="userPd ps-card">
                <PhotoGrid
                      photos={baseImageLogo}
                      slots={viewSlotsFor(form)}
                      skipped={normalizeSkipped(form?.mediaViewsSkipped)}
                      onAddFiles={(files, view) =>
                        uploadFiles({ fileArr: fileArrayLogo, fileObject: fileObjLogo, name: "logo", files, view })
                      }
                      onSetView={onSetPhotoView}
                      onSkipView={onSkipPhotoView}
                      onPin={onSetPin}
                      onToggleShow={onSetIndexDesign}
                      onDelete={handleDeleteLogo}
                      nameParts={{ sku: form?.productCertificateNumber, name: form?.productName, loomNum: form?.loomNum }}
                      onPreview={(item) => {
                        handleOpen();
                        handleSetImage(item);
                      }}
                    />
                <div className="d-flex justify-content-center">
                  {productMainImageStatusCode?.length > 0 &&
                    productMainImageStatusCode[0] !== 200 ? (
                    <p className="RequiredField">
                      Image upload failed into server!
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="hkp-product-draft-status">
                  {!isDraftStatus(form?.status) ? (
                    <span className="hkp-product-draft-status__badge">
                      {hasDraftChanges
                        ? `Live r${form?.publishedRevision || 1} · Draft r${form?.draftRevision || (form?.publishedRevision || 1) + 1}`
                        : `Live r${form?.publishedRevision || 1}`}
                    </span>
                  ) : (
                    <span className="hkp-product-draft-status__badge">Draft</span>
                  )}
                  {uploadSummary.uploaded +
                    uploadSummary.uploading +
                    uploadSummary.queued +
                    uploadSummary.failed >
                  0 ? (
                    <span className="hkp-product-draft-status__queue">
                      {uploadSummary.uploaded} uploaded · {uploadSummary.uploading}{" "}
                      uploading · {uploadSummary.queued} queued ·{" "}
                      <span
                        className={
                          uploadSummary.failed
                            ? "hkp-product-draft-status__failed"
                            : undefined
                        }
                      >
                        {uploadSummary.failed} failed
                      </span>
                    </span>
                  ) : null}
                </div>
                  </div>
                  <p className="ps-note">
                      <b>Nothing here is required.</b> Empty boxes are the reminder — blouse and video are the ones studios miss. Tap one to shoot it, already tagged; extra photos can be tagged later.
                    </p>
                </ProductStepPanel>
                <ProductStepPanel id="basics" active={step}>
                  <div className="userPd ps-card">
                    <div className="formDiv">
                      <Row className="ps-row-2">
                    <Col xs={12} md={4}>
                      <Label>
                        Product name<span>*</span>
                          {form?.orgSrNo ? <i className="ps-label-hint" title="Set automatically, one number per piece">Studio SN #{form.orgSrNo}</i> : null}
                      </Label>
                      <Input
                        name="productName"
                        id="productName"
                        className="form-control"
                        placeholder="e.g. Chiffon jangla butidar, meena pallu"
                        value={form?.productName}
                        // disabled={
                        //   form?.typeOfSareeByDesign?.value?.length > 0
                        //     ? true
                        //     : false
                        // }
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "productName",
                            value: e.target.value,
                          });
                          handleChangeDebounce({
                            name: "product",
                            artform: form?.artform?.value,
                            type: form?.type?.value,
                            category: form?.category?.value,
                            subCategory: form?.subCategory?.value,
                            weaveType: form?.weaveType?.value,
                            productName: e.target.value,
                          });
                        }}
                      />
                      {Error.product && !form?.productName ? (
                        <p className="RequiredField">{Error?.product} </p>
                      ) : (
                        ""
                      )}
                      {form?.productName &&
                        form?.productName === filterProduct ? (
                        // filterValue?.product === ""
                        <p className="RequiredField">
                          Product name already exists
                        </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        Colour<span>*</span>
                          <i className="ps-label-hint">tap or type</i>
                      </Label>
                      <Input
                        name="variantColor"
                        id="variantColor"
                        className="form-control"
                        placeholder="e.g. Peacock blue, gold border"
                        value={form?.variantCode}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "variantCode",
                            value: e.target.value,
                          });
                        }}
                      />
                        <ColourChips
                          value={form?.variantCode}
                          onPick={(value) => handleOnInputChange({ name: "variantCode", value })}
                        />
                      {Error.variantCode && !form?.variantCode ? (
                        <p className="RequiredField">{Error?.variantCode} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                      </Row>
                    </div>
                    <div className="formDiv">
                      <CategoryPathPicker
                        value={form}
                        onPick={pickCategoryPath}
                        levelsOpen={levelsOpen}
                        onShowLevels={() => setLevelsOpen(true)}
                      />
                    </div>
                    {levelsOpen ? (
                      <div className="formDiv ReactSelectDiv">
                        <Row>
                    <Col xs={12} md={4}>
                      <Label>
                        Artform<span>*</span>
                      </Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          isSearchable
                          name="artform"
                          id="artform"
                          value={form?.artform}
                          options={artformOptions}
                          // components={{ MenuList: SelectMenuButton }}
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "artform",
                              value: e,
                            });
                          }}
                          onInputChange={(e) =>
                            handleOnInputChangeFilters({
                              name: "artform",
                              value: e,
                            })
                          }
                        />
                        <div className="DivSep"></div>
                        <div className="formAddDiv">
                          <AddIcon openModal={handleOpenArtform} />
                        </div>
                      </div>
                      {Error.artform && !masterIdFromRef(form?.artform) ? (
                        <p className="RequiredField">{Error?.artform} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        Type<span>*</span>
                      </Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          isSearchable
                          name="type"
                          id="type"
                          value={form?.type}
                          // components={
                          //   form?.artform?.value && {
                          //     MenuList: SelectMenuButtonForType,
                          //   }
                          // }
                          options={
                            form?.artform?.value
                              ? typeOptions
                              : [
                                {
                                  label: (
                                    <p className="req">
                                      ***Please select Artform***
                                    </p>
                                  ),
                                  value: "",
                                },
                              ]
                          }
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "type",
                              value: e,
                            });
                          }}
                          onInputChange={(e) =>
                            handleOnInputChangeFilters({
                              name: "type",
                              value: e,
                            })
                          }
                        />
                        <div className="DivSep"></div>
                        <div className="formAddDiv">
                          <AddIcon openModal={handleOpenType} />
                        </div>
                      </div>
                      {Error.type && !masterIdFromRef(form?.type) ? (
                        <p className="RequiredField">{Error?.type} </p>
                      ) : (
                        ""
                      )}
                      {/* {filterValue?.type &&
                      new Map(
                        typeOptions.map((obj: any) => {
                          return [obj.value, obj.labe];
                        })
                      ).has(filterValue?.type) == false ? (
                        <p className="RequiredField">
                          Type is not a part of selected artform
                        </p>
                      ) : (
                        ""
                      )} */}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        Category<span>*</span>
                      </Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          isSearchable
                          name="Category"
                          id="Category"
                          value={form?.category}
                          // components={
                          //   form?.type?.value && {
                          //     MenuList: SelectMenuButtonForCategory,
                          //   }
                          // }
                          options={
                            form?.type?.value
                              ? categoryOptions
                              : [
                                {
                                  label: (
                                    <p className="req">
                                      ***Please select type***
                                    </p>
                                  ),
                                  value: "",
                                },
                              ]
                          }
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "category",
                              value: e,
                            });
                          }}
                          onInputChange={(e) =>
                            handleOnInputChangeFilters({
                              name: "category",
                              value: e,
                            })
                          }
                        />
                        <div className="DivSep"></div>
                        <div className="formAddDiv">
                          <AddIcon openModal={handleOpenCategory} />
                        </div>
                      </div>
                      {Error.category && !masterIdFromRef(form?.category) ? (
                        <p className="RequiredField">{Error?.category} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>
                        Sub-Category<span>*</span>
                      </Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          isSearchable
                          name="subCategory"
                          id="subCategory"
                          value={form?.subCategory}
                          // components={
                          //   form?.category?.value && {
                          //     MenuList: SelectMenuButtonForSubCategory,
                          //   }
                          // }
                          options={
                            form?.category?.value
                              ? subCategoryOptions
                              : [
                                {
                                  label: (
                                    <p className="req">
                                      ***Please select category***
                                    </p>
                                  ),
                                  value: "",
                                },
                              ]
                          }
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "subCategory",
                              value: e,
                            });
                          }}
                          onInputChange={(e) =>
                            handleOnInputChangeFilters({
                              name: "subCategory",
                              value: e,
                            })
                          }
                        />
                        <div className="DivSep"></div>
                        <div className="formAddDiv">
                          <AddIcon openModal={handleOpenSubCategory} />
                        </div>
                      </div>
                      {Error.subCategory && !masterIdFromRef(form?.subCategory) ? (
                        <p className="RequiredField">{Error?.subCategory} </p>
                      ) : (
                        ""
                      )}
                      {/* {filterValue?.subCategory &&
                      new Map(
                        subCategoryOptions.map((obj: any) => {
                          return [obj.value, obj.labe];
                        })
                      ).has(filterValue?.subCategory) == false ? (
                        <p className="RequiredField">
                          Sub-Category is not a part of selected category
                        </p>
                      ) : (
                        ""
                      )} */}
                    </Col>
                    {weaveTypeApplicable ? (
                    <Col xs={12} md={4}>
                      <Label>
                        Weave Type<span>*</span>
                      </Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          isSearchable
                          name="weaveType"
                          id="weaveType"
                          value={form?.weaveType}
                          options={
                            form?.subCategory?.value
                              ? weaveTypeOptions
                              : [
                                {
                                  label: (
                                    <p className="req">
                                      ***Please select sub-category***
                                    </p>
                                  ),
                                  value: "",
                                },
                              ]
                          }
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "weaveType",
                              value: e,
                            });
                          }}
                          onInputChange={(e) =>
                            handleOnInputChangeFilters({
                              name: "weaveType",
                              value: e,
                            })
                          }
                        />
                        <div className="formAddDiv">
                          <AddIcon openModal={handleOpenWeaveType} />
                        </div>
                      </div>
                      {Error.weaveType && !masterIdFromRef(form?.weaveType) ? (
                        <p className="RequiredField">{Error?.weaveType} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    ) : null}
                        </Row>
                      </div>
                    ) : null}
                    <div className="formDiv">
                      <Row>
                    <ProductDescriptionField
                      value={form?.description}
                      onChange={(value) =>
                        handleOnInputChange({ name: "description", value })
                      }
                    />
                      </Row>
                      <WriteFromPhotos
                        form={form}
                        photos={baseImageLogo}
                        onWrite={(value) => handleOnInputChange({ name: "description", value })}
                      />
                    </div>
                {/* Photo AI reads the saved cover photo: hide it until there is one (or results to show). */}
                {(previewPhoto && !previewPhoto.startsWith("blob:")) || aiEnrichment ? (
                  <ProductAiSuggestions
                    productId={form?.id || ProductId}
                    aiEnrichment={aiEnrichment}
                    enrichProductAi={props.enrichProductAi}
                    acceptProductAi={props.acceptProductAi}
                    rejectProductAi={props.rejectProductAi}
                    getSimilarProducts={props.getSimilarProducts}
                    onApplied={getAllData}
                  />
                ) : null}
                    <div className="formDiv hkp-product-flags">
                      <Row>
                    <Col xs={6} md={4}>
                      <Label>In stock</Label>
                      {isDraftStatus(form?.status) ? (
                        <p className="product-stock-progress mb-0">
                          In progress — publishing will mark this in stock
                        </p>
                      ) : (
                        <div className="hkp-stock-pick" role="group" aria-label="In stock">
                          <button
                            type="button"
                            className={`hkp-stock-pick__btn${form?.inStock === true ? " is-on" : ""}`}
                            aria-pressed={form?.inStock === true}
                            onClick={() => setForm({ ...form, inStock: true })}
                          >
                            Yes
                          </button>
                          <button
                            type="button"
                            className={`hkp-stock-pick__btn${form?.inStock !== true ? " is-on" : ""}`}
                            aria-pressed={form?.inStock !== true}
                            onClick={() => setForm({ ...form, inStock: false })}
                          >
                            No
                          </button>
                        </div>
                      )}
                    </Col>
                      </Row>
                    </div>
                  </div>
                </ProductStepPanel>
                <ProductStepPanel id="details" active={step}>
                  <p className="ps-note ps-note--ok">
                    All optional — fill what you know.
                    {isSareeLikeProduct(form) ? " Saree fields show because the category is a saree." : ""}
                  </p>
                  <DetailsGroup
                    title="Price · only your team sees"
                    summary={[form?.sellPrice ? `SP ${formatRupee(form.sellPrice)}` : "", form?.costPrice ? `CP ${formatRupee(form.costPrice)}` : ""].filter(Boolean).join(" · ") || "selling and cost price"}
                    defaultOpen
                  >
                    <ProductInternalUseSection
                      title=""
                      masked={false}
                      sellPrice={form?.sellPrice}
                      costPrice={form?.costPrice}
                      productUniqueId={form?.productUniqueId}
                      onChange={handleOnInputChange}
                    />
                  </DetailsGroup>
                  <DetailsGroup
                    title={isSareeLikeProduct(form) ? "Saree details" : "Material & weight"}
                    summary={groupSummary(form, isSareeLikeProduct(form) ? ["typeOfSareeByDesign", ...DETAIL_GROUP_KEYS.material] : DETAIL_GROUP_KEYS.material, "design, zari, weight, yarn, time, hours")}
                    defaultOpen
                  >
                    <div className="formDiv">
                      <Row>
                    {isSareeLikeProduct(form) ? (
                    <Col xs={12} md={4}>
                      <Label>Types of sarees by design</Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          // isSearchable
                          name="typeOfSareeByDesign"
                          value={form?.typeOfSareeByDesign}
                          options={typeOfSareeByDesignOptions}
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "typeOfSareeByDesign",
                              value: e,
                            });
                          }}
                        />
                      </div>
                    </Col>
                    ) : null}
                    <Col xs={12} md={4}>
                      <Label>Zari Used</Label>
                      <div className="formDivSub">
                        <Select
                          className="React_selector text-white"
                          classNamePrefix="react-select"
                          placeholder="Select"
                          autoFocus={false}
                          isSearchable
                          name="zariUsed"
                          id="zariUsed"
                          value={
                            form?.zariUsed?.label === "None"
                              ? ""
                              : form?.zariUsed?.label?.length
                                ? form?.zariUsed
                                : ""
                          }
                          options={zariUsedOptions}
                          onChange={(e: any) => {
                            handleOnInputChange({
                              name: "zariUsed",
                              value: e,
                            });
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Purity of Zari</Label>
                      <Input
                        type="textarea"
                        name="purityOfZari"
                        id="purityOfZari"
                        className="form-control"
                        placeholder="Purity of zari"
                        defaultValue={form?.zariUsed?.value}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>{productWeightLabel(form)}</Label>
                      <Input
                        name="weightOfSaree"
                        id="weightOfSaree"
                        className="form-control"
                        placeholder="Weight of saree"
                        value={form?.weightOfSaree}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "weightOfSaree",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Weight of Zari used(in Grams)</Label>
                      <Input
                        type="text"
                        name="weightOfZariUsed"
                        id="weightOfZariUsed"
                        className="form-control"
                        placeholder="Weight of Zari used"
                        value={form?.weightOfZariUsed}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "weightOfZariUsed",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Yarn type </Label>
                      <Select
                        className="React_selector text-white"
                        classNamePrefix="react-select"
                        placeholder="Select"
                        isSearchable
                        name="yarnType"
                        value={form?.yarnType}
                        options={yarnUsedOptions}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "yarnType",
                            value: e,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Time Taken in months </Label>
                      <Select
                        className="React_selector text-white"
                        classNamePrefix="react-select"
                        placeholder="Select"
                        isSearchable
                        name="timeTakenInMonths"
                        value={form?.productionTimeInMonths}
                        options={timeTakenInMonthsOptions}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "timeTakenInMonths",
                            value: e,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Working Hours </Label>
                      <Input
                        type="text"
                        name="workingHours"
                        id="workingHours"
                        className="form-control"
                        placeholder="Working Hours"
                        value={form?.workingHours}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "workingHours",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                      </Row>
                    </div>
                  </DetailsGroup>
                  <DetailsGroup title="Origin" summary={groupSummary(form, DETAIL_GROUP_KEYS.origin, "weaving centre, GI, loom, brand, weaver")}>
                    <div className="formDiv">
                      <Row>
                    <Col xs={12} md={4}>
                      <Label>Weaving Center</Label>
                      <Input
                        name="weavingCenter"
                        className="form-control"
                        placeholder="Weaving Center"
                        value={form?.weavingCenter}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "weavingCenter",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <GiFrozenSelect
                        value={form?.giId || ""}
                        onChange={(giId) =>
                          handleOnInputChange({
                            name: "giId",
                            value: giId,
                          })
                        }
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Loom Number </Label>
                      <LoomNumberField
                        value={form?.loomNum}
                        onChange={(loomNum) => handleOnInputChange({ name: "loomNum", value: loomNum })}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Name of Brand</Label>
                      <Input
                        name="nameOfBrand"
                        id="nameOfBrand"
                        className="form-control"
                        placeholder="Name of brand"
                        value={form?.nameOfBrand}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "nameOfBrand",
                            value: e.target.value,
                          });
                        }}
                      />
                      {Error.nameOfBrand && !form?.nameOfBrand ? (
                        <p className="RequiredField">{Error?.nameOfBrand} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Name of weaver</Label>
                      <Input
                        name="nameOfWeaver"
                        id="nameOfWeaver"
                        className="form-control"
                        placeholder="Name of weaver"
                        value={form?.nameOfWeaver}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "nameOfWeaver",
                            value: e.target.value,
                          });
                        }}
                      />
                      {Error.nameOfWeaver && !form?.nameOfWeaver ? (
                        <p className="RequiredField">{Error?.nameOfWeaver} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                      </Row>
                    </div>
                  </DetailsGroup>
                  <DetailsGroup title="Marks & numbers" summary={groupSummary(form, DETAIL_GROUP_KEYS.marks, "silk mark, handloom mark, design no., HKP tag, HKP ID")}>
                    <div className="formDiv">
                      <Row>
                    <Col xs={6} md={4} lg={4}>
                      <Label>Silk Mark Number</Label>
                      <Input
                        type="text"
                        name="silkMark"
                        className="form-control"
                        placeholder="Slik mark number"
                        value={form?.silkMark}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "silkMark",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <Label>Handloom Mark Number</Label>
                      <Input
                        type="text"
                        name="handloomMark"
                        className="form-control"
                        placeholder="Handloom mark number"
                        value={form?.handloomMark}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "handloomMark",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <Label>Design Number</Label>
                      <Input
                        type="text"
                        name="designNum"
                        className="form-control"
                        placeholder="Design Number"
                        value={form?.designNum}
                        onChange={(e: any) => {
                          handleOnInputChange({
                            name: "designNum",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={6} md={4}>
                      <Label>
                        HKPtagNo
                      </Label>
                      <Input
                        name="SrNo"
                        id="SrNo"
                        className="form-control"
                        placeholder="HKP tag number"
                        value={form?.SrNo}
                        onChange={(e: any) => {
                          const value = e.target.value;
                          if (form?.xuidFromRegistry) {
                            setForm((current: any) => ({
                              ...current,
                              SrNo: value,
                              xuid: "",
                              xuidFromRegistry: false,
                            }));
                          } else {
                            handleOnInputChange({
                              name: "SrNo",
                              value,
                            });
                          }
                        }}
                        onBlur={(e: any) => handleHkpTagNoBlur(e.target.value)}
                      />
                      {Error.SrNo && !form?.SrNo ? (
                        <p className="RequiredField">{Error?.SrNo} </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col xs={6} md={4}>
                      <Label>HKP ID </Label>
                      <Input
                        style={{
                          textTransform: "none",
                        }}
                        type="text"
                        name="xuid"
                        className="form-control"
                        placeholder="HKP ID"
                        value={form?.xuid}
                        readOnly={!!form?.xuidFromRegistry}
                        onChange={(e: any) => {
                          if (form?.xuidFromRegistry) {
                            return;
                          }
                          handleOnInputChange({
                            name: "xuid",
                            value: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={6} md={4}>
                      <Label>Made in India</Label>
                      <p className="hkp-made-in-india mb-0">Yes</p>
                    </Col>
                      </Row>
                    </div>
                  </DetailsGroup>
                  <DetailsGroup
                    title="Your attributes & tags"
                    summary={`${productTaxonomyFields.length} studio field${productTaxonomyFields.length === 1 ? "" : "s"} · ${(form?.tags || []).length} tag${(form?.tags || []).length === 1 ? "" : "s"}`}
                    defaultOpen={missingPublishFields.length > 0}
                    badge={
                      missingPublishFields.length ? (
                        <span className="ps-chip ps-chip--draft">{missingPublishFields.length} needed</span>
                      ) : null
                    }
                  >
                <ProductAttributesSection
                  fields={productTaxonomyFields}
                  values={form?.taxonomyValues || {}}
                  loading={taxonomyConfigLoading}
                  error={taxonomyConfigError}
                  missing={missingPublishFields}
                  showHistorical
                  productId={ProductId || form?.id}
                  onChange={(taxonomyValues) =>
                    setForm((current: any) => ({ ...current, taxonomyValues }))
                  }
                  hideSummary
                  />
                    <div className="formDiv">
                      <Row>
                    <Col xs={12} md={4}>
                      <Label>Add Tags</Label>
                      <ReactChipInput
                        {...props}
                        classes="class1 class2"
                        chips={form.tags ? form?.tags : []}
                        onSubmit={(value: any) => addChip(value)}
                        onRemove={(index: any) => removeChip(index)}
                      />
                    </Col>
                      </Row>
                    </div>
                  </DetailsGroup>
                  {isTypeTagsEnabled() ? (
                    <DetailsGroup
                      title="Type tags"
                      summary={`${(form?.typeTagIds || []).length} selected`}
                      defaultOpen={(form?.typeTagIds || []).length > 0 || form?.typeTagReview?.status === "PENDING"}
                      badge={
                        form?.typeTagReview?.status === "PENDING" ? <span className="ps-chip ps-chip--draft">Check</span> : null
                      }
                    >
                      <TypeTagReviewBanner
                        review={form?.typeTagReview}
                        productUniqueId={form?.productUniqueId || ProductId}
                        onConfirmed={(typeTagIds) =>
                          setForm((current: any) => ({ ...current, typeTagIds, typeTagReview: { status: "CONFIRMED" } }))
                        }
                      />
                      <p className="ps-note">
                        Add every type that fits (katan, tanchoi, butidar…). Your category above stays the official record.
                      </p>
                      <TypeTagPicker
                        suggestFrom={{ name: form?.productName, subcategoryName: form?.subCategory?.label }}
                        value={form?.typeTagIds || []}
                        onChange={(typeTagIds) => setForm((current: any) => ({ ...current, typeTagIds }))}
                      />
                    </DetailsGroup>
                  ) : null}
                  <ProductCareSection productUniqueId={form?.productUniqueId || ProductId} productName={form?.productName} />
                </ProductStepPanel>
                <ProductStepPanel id="making" active={step}>
                  <p className="ps-note">
                    Who made it, with photos from the loom. Use <b>Ask to capture</b> to send the artisan a link — they shoot
                    live from the loom. Buyers see this on the certificate.
                  </p>
                <ProcessStepsSection
                  processSteps={form?.processSteps}
                  setProcessSteps={(steps) => setForm({ ...form, processSteps: steps })}
                />
            <FlexibleMediaProcessesSection
              slots={form.flexUploadSlots}
              onSlotsChange={(next) => {
                setFlexUploadDirty(true);
                flexSlotsRef.current = next;
                setForm((current: any) => ({ ...current, flexUploadSlots: next }));
              }}
              onFilesPicked={onFlexFilesPicked}
              designerOptions={designerOptions}
              weaverOptions={weaverOptions}
              dyerOptions={dyerOptions}
              finisherOptions={finisherOptions}
              loader={loader}
              openCreateArtisanModal={() =>
                handleOpenModal({ name: "designing", value: true })
              }
              onDeletePreview={onFlexDeletePreview}
              onDeleteMany={onFlexDeleteMany}
              onToggleShow={onFlexToggleShow}
              processMasterOptions={processMasterOptions}
              onCreateProcessMaster={createProcessMaster}
              productId={ProductId || form?.id}
              processFields={processTaxonomyFields}
              organizationId={authUser?.users?.organizationResponse?._id || organizationId}
              variant="steps"
              openKeys={(form.flexUploadSlots || [])
                .filter((slot: any) =>
                  missingPublishFields.some((field) => String(field.focusId || "").startsWith(`hkp-tax-process-${slot.key}-`))
                )
                .map((slot: any) => slot.key)}
            />
                </ProductStepPanel>
                <ProductStepPanel id="review" active={step}>
                  <div className="ps-card ps-preview">
                    {previewPhoto ? <PreviewCoverImage url={previewPhoto} /> : <span className="ps-preview__ph" />}
                    <div>
                      <strong>{form?.productName || "Untitled piece"}</strong>
                      <small>
                        {[form?.orgSrNo ? `#${form.orgSrNo}` : "", form?.category?.label || form?.category?.name, form?.variantCode]
                          .filter(Boolean)
                          .join(" · ")}
                      </small>
                      {form?.sellPrice ? <strong>₹{Number(form.sellPrice).toLocaleString("en-IN")}</strong> : null}
                      <small>This is how it shows in your list</small>
                    </div>
                  </div>
                  <div className="ps-card">
                    <div className="ps-label">
                      <span>{isDraftStatus(form?.status) ? "Left for when it’s finished" : "Ready to publish?"}</span>
                    </div>
                    <ReviewChecklist items={reviewItems} onJump={jumpFromReview} />
                  </div>
                  {isDraftStatus(form?.status) ? (
                    <p className="ps-note">
                      It stays a <b>draft while it’s on the loom</b>. Add making photos as weaving goes on. When it’s
                      finished, press <b>Publish</b>: it goes live and in stock, ready for HKP tag / QR, catalogue or
                      transfer.
                    </p>
                  ) : null}
                </ProductStepPanel>
              </div>
            </div>
          </main>
          <aside className="ps-aside">
            <span className="ps-aside__label">Preview in your list</span>
            <div className="ps-aside__card">
              {previewPhoto ? <PreviewCoverImage url={previewPhoto} /> : <span className="ps-preview__ph" />}
              <div>
                <strong>{form?.productName || "Untitled piece"}</strong>
                <small>
                  {[form?.orgSrNo ? `#${form.orgSrNo}` : "", form?.variantCode].filter(Boolean).join(" · ")}
                </small>
                {form?.sellPrice ? <strong>₹{Number(form.sellPrice).toLocaleString("en-IN")}</strong> : null}
              </div>
            </div>
          </aside>
          <ProductStepFooter>
            {previousStep(step) ? (
              <StepButton onClick={() => goToStep(previousStep(step) as ProductStepId)}>Back</StepButton>
            ) : null}
            <StepButton
              kind={step !== "review" ? "ghost" : isDraftStatus(form?.status) ? "blue" : "line"}
              wide={step === "review" && isDraftStatus(form?.status)}
              onClick={() => handleSubmit({ status: isDraftStatus(form?.status) ? 0 : 1 }, "save")}
              disabled={Boolean(loader || loading || saving)}
              aria-busy={saving === "save"}
            >
              {saving === "save"
                ? "Saving…"
                : isProductDraftRevisionsEnabled() || isDraftStatus(form?.status)
                  ? "Save draft"
                  : "Save"}
            </StepButton>
            {step !== "review" ? (
              <StepButton kind="blue" wide next onClick={() => goToStep(nextStep(step) as ProductStepId)}>
                {`Next: ${PRODUCT_STEPS[stepIndex(step) + 1].label}`}
              </StepButton>
            ) : (
              <StepButton
                // A piece on the loom stays a draft: Save draft leads, Publish is for when it's finished.
                // Without a photo it can't go live, so the button says so and leads to Photos.
                kind={isDraftStatus(form?.status) ? "line" : "blue"}
                wide={!isDraftStatus(form?.status)}
                onClick={() =>
                  needsPhotoToPublish
                    ? goToStep("photos")
                    : liveWithDraftRevisions
                      ? setPublishSheetOpen(true)
                      : handleSubmit({ status: 1, publishDraft: !isDraftStatus(form?.status) }, "publish")
                }
                disabled={
                  Boolean(loader || loading || saving) ||
                  (isProductDraftRevisionsEnabled() && uploadSummary.unresolved > 0)
                }
                aria-busy={saving === "publish"}
              >
                {saving === "publish"
                  ? "Publishing…"
                  : needsPhotoToPublish
                    ? "Add a photo to publish"
                    : isDraftStatus(form?.status)
                      ? "Publish (finished)"
                      : "Publish changes"}
              </StepButton>
            )}
          </ProductStepFooter>
          <PublishChangesSheet
            open={publishSheetOpen}
            changes={draftChanges(pendingDraftFromForm(rawLiveProduct, form))}
            unsavedOnScreen
            busy={saving === "publish"}
            onKeep={() => setPublishSheetOpen(false)}
            onPublish={() => {
              setPublishSheetOpen(false);
              handleSubmit({ status: 1, publishDraft: true }, "publish");
            }}
            goodToHave={missingPhotoViews}
            onAddViews={() => {
              setPublishSheetOpen(false);
              goToStep("photos");
            }}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  getProducts,
  getArtforms,
  getTypes,
  getCategory,
  getSubCategorys,
  getWeaveType,
  getUsers,
  createUser,
  updateUsers,
  uploadImages,
  fetchProfilePresignedUrl,
  fetchProductWeavingPresignedUrl,
  fetchProductDesigningPresignedUrl,
  fetchProductFinishingPresignedUrl,
  fetchProductDyingPresignedUrl,
  updateProducts,
  uploadImages1,
  createVariantForProduct,
  enrichProductAi,
  acceptProductAi,
  rejectProductAi,
  getSimilarProducts,
})(EditProduct);
